!function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
    : t(e)
}("undefined" != typeof window ? window : this, function(C, e) {
    "use strict";
    function g(e) {
        return null != e && e === e.window
    }
    var t = []
      , n = Object.getPrototypeOf
      , a = t.slice
      , v = t.flat ? function(e) {
        return t.flat.call(e)
    }
    : function(e) {
        return t.concat.apply([], e)
    }
      , l = t.push
      , r = t.indexOf
      , i = {}
      , o = i.toString
      , m = i.hasOwnProperty
      , s = m.toString
      , u = s.call(Object)
      , y = {}
      , x = function(e) {
        return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item
    }
      , E = C.document
      , c = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
    };
    function b(e, t, n) {
        var i, r, o = (n = n || E).createElement("script");
        if (o.text = e,
        t)
            for (i in c)
                (r = t[i] || t.getAttribute && t.getAttribute(i)) && o.setAttribute(i, r);
        n.head.appendChild(o).parentNode.removeChild(o)
    }
    function h(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? i[o.call(e)] || "object" : typeof e
    }
    var f = "3.6.0"
      , S = function(e, t) {
        return new S.fn.init(e,t)
    };
    function d(e) {
        var t = !!e && "length"in e && e.length
          , n = h(e);
        return !x(e) && !g(e) && ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
    }
    S.fn = S.prototype = {
        jquery: f,
        constructor: S,
        length: 0,
        toArray: function() {
            return a.call(this)
        },
        get: function(e) {
            return null == e ? a.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            e = S.merge(this.constructor(), e);
            return e.prevObject = this,
            e
        },
        each: function(e) {
            return S.each(this, e)
        },
        map: function(n) {
            return this.pushStack(S.map(this, function(e, t) {
                return n.call(e, t, e)
            }))
        },
        slice: function() {
            return this.pushStack(a.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(S.grep(this, function(e, t) {
                return (t + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(S.grep(this, function(e, t) {
                return t % 2
            }))
        },
        eq: function(e) {
            var t = this.length
              , e = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= e && e < t ? [this[e]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: l,
        sort: t.sort,
        splice: t.splice
    },
    S.extend = S.fn.extend = function() {
        var e, t, n, i, r, o = arguments[0] || {}, s = 1, a = arguments.length, l = !1;
        for ("boolean" == typeof o && (l = o,
        o = arguments[s] || {},
        s++),
        "object" == typeof o || x(o) || (o = {}),
        s === a && (o = this,
        s--); s < a; s++)
            if (null != (e = arguments[s]))
                for (t in e)
                    n = e[t],
                    "__proto__" !== t && o !== n && (l && n && (S.isPlainObject(n) || (i = Array.isArray(n))) ? (r = o[t],
                    r = i && !Array.isArray(r) ? [] : i || S.isPlainObject(r) ? r : {},
                    i = !1,
                    o[t] = S.extend(l, r, n)) : void 0 !== n && (o[t] = n));
        return o
    }
    ,
    S.extend({
        expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            return !(!e || "[object Object]" !== o.call(e) || (e = n(e)) && ("function" != typeof (e = m.call(e, "constructor") && e.constructor) || s.call(e) !== u))
        },
        isEmptyObject: function(e) {
            for (var t in e)
                return !1;
            return !0
        },
        globalEval: function(e, t, n) {
            b(e, {
                nonce: t && t.nonce
            }, n)
        },
        each: function(e, t) {
            var n, i = 0;
            if (d(e))
                for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++)
                    ;
            else
                for (i in e)
                    if (!1 === t.call(e[i], i, e[i]))
                        break;
            return e
        },
        makeArray: function(e, t) {
            t = t || [];
            return null != e && (d(Object(e)) ? S.merge(t, "string" == typeof e ? [e] : e) : l.call(t, e)),
            t
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : r.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, r = e.length; i < n; i++)
                e[r++] = t[i];
            return e.length = r,
            e
        },
        grep: function(e, t, n) {
            for (var i = [], r = 0, o = e.length, s = !n; r < o; r++)
                !t(e[r], r) != s && i.push(e[r]);
            return i
        },
        map: function(e, t, n) {
            var i, r, o = 0, s = [];
            if (d(e))
                for (i = e.length; o < i; o++)
                    null != (r = t(e[o], o, n)) && s.push(r);
            else
                for (o in e)
                    null != (r = t(e[o], o, n)) && s.push(r);
            return v(s)
        },
        guid: 1,
        support: y
    }),
    "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
    S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        i["[object " + t + "]"] = t.toLowerCase()
    });
    var p = function(n) {
        function f(e, t) {
            return e = "0x" + e.slice(1) - 65536,
            t || (e < 0 ? String.fromCharCode(65536 + e) : String.fromCharCode(e >> 10 | 55296, 1023 & e | 56320))
        }
        function i() {
            T()
        }
        var e, p, b, o, r, h, d, g, w, l, u, T, C, s, E, v, a, c, m, S = "sizzle" + +new Date, y = n.document, N = 0, x = 0, k = le(), A = le(), D = le(), j = le(), L = function(e, t) {
            return e === t && (u = !0),
            0
        }, P = {}.hasOwnProperty, t = [], q = t.pop, O = t.push, H = t.push, I = t.slice, M = function(e, t) {
            for (var n = 0, i = e.length; n < i; n++)
                if (e[n] === t)
                    return n;
            return -1
        }, $ = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", R = "[\\x20\\t\\r\\n\\f]", _ = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", F = "\\[" + R + "*(" + _ + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + _ + "))|)" + R + "*\\]", W = ":(" + _ + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)", B = new RegExp(R + "+","g"), z = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$","g"), V = new RegExp("^" + R + "*," + R + "*"), U = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"), X = new RegExp(R + "|>"), Q = new RegExp(W), Y = new RegExp("^" + _ + "$"), G = {
            ID: new RegExp("^#(" + _ + ")"),
            CLASS: new RegExp("^\\.(" + _ + ")"),
            TAG: new RegExp("^(" + _ + "|[*])"),
            ATTR: new RegExp("^" + F),
            PSEUDO: new RegExp("^" + W),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)","i"),
            bool: new RegExp("^(?:" + $ + ")$","i"),
            needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)","i")
        }, J = /HTML$/i, K = /^(?:input|select|textarea|button)$/i, Z = /^h\d$/i, ee = /^[^{]+\{\s*\[native \w/, te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ne = /[+~]/, ie = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])","g"), re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, oe = function(e, t) {
            return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
        }, se = ye(function(e) {
            return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            H.apply(t = I.call(y.childNodes), y.childNodes),
            t[y.childNodes.length].nodeType
        } catch (e) {
            H = {
                apply: t.length ? function(e, t) {
                    O.apply(e, I.call(t))
                }
                : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++]; )
                        ;
                    e.length = n - 1
                }
            }
        }
        function ae(e, t, n, i) {
            var r, o, s, a, l, u, c, f = t && t.ownerDocument, d = t ? t.nodeType : 9;
            if (n = n || [],
            "string" != typeof e || !e || 1 !== d && 9 !== d && 11 !== d)
                return n;
            if (!i && (T(t),
            t = t || C,
            E)) {
                if (11 !== d && (l = te.exec(e)))
                    if (r = l[1]) {
                        if (9 === d) {
                            if (!(s = t.getElementById(r)))
                                return n;
                            if (s.id === r)
                                return n.push(s),
                                n
                        } else if (f && (s = f.getElementById(r)) && m(t, s) && s.id === r)
                            return n.push(s),
                            n
                    } else {
                        if (l[2])
                            return H.apply(n, t.getElementsByTagName(e)),
                            n;
                        if ((r = l[3]) && p.getElementsByClassName && t.getElementsByClassName)
                            return H.apply(n, t.getElementsByClassName(r)),
                            n
                    }
                if (p.qsa && !j[e + " "] && (!v || !v.test(e)) && (1 !== d || "object" !== t.nodeName.toLowerCase())) {
                    if (c = e,
                    f = t,
                    1 === d && (X.test(e) || U.test(e))) {
                        for ((f = ne.test(e) && ge(t.parentNode) || t) === t && p.scope || ((a = t.getAttribute("id")) ? a = a.replace(re, oe) : t.setAttribute("id", a = S)),
                        o = (u = h(e)).length; o--; )
                            u[o] = (a ? "#" + a : ":scope") + " " + me(u[o]);
                        c = u.join(",")
                    }
                    try {
                        return H.apply(n, f.querySelectorAll(c)),
                        n
                    } catch (t) {
                        j(e, !0)
                    } finally {
                        a === S && t.removeAttribute("id")
                    }
                }
            }
            return g(e.replace(z, "$1"), t, n, i)
        }
        function le() {
            var i = [];
            return function e(t, n) {
                return i.push(t + " ") > b.cacheLength && delete e[i.shift()],
                e[t + " "] = n
            }
        }
        function ue(e) {
            return e[S] = !0,
            e
        }
        function ce(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                t = null
            }
        }
        function fe(e, t) {
            for (var n = e.split("|"), i = n.length; i--; )
                b.attrHandle[n[i]] = t
        }
        function de(e, t) {
            var n = t && e
              , i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (i)
                return i;
            if (n)
                for (; n = n.nextSibling; )
                    if (n === t)
                        return -1;
            return e ? 1 : -1
        }
        function pe(t) {
            return function(e) {
                return "form"in e ? e.parentNode && !1 === e.disabled ? "label"in e ? "label"in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && se(e) === t : e.disabled === t : "label"in e && e.disabled === t
            }
        }
        function he(s) {
            return ue(function(o) {
                return o = +o,
                ue(function(e, t) {
                    for (var n, i = s([], e.length, o), r = i.length; r--; )
                        e[n = i[r]] && (e[n] = !(t[n] = e[n]))
                })
            })
        }
        function ge(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }
        for (e in p = ae.support = {},
        r = ae.isXML = function(e) {
            var t = e && e.namespaceURI
              , e = e && (e.ownerDocument || e).documentElement;
            return !J.test(t || e && e.nodeName || "HTML")
        }
        ,
        T = ae.setDocument = function(e) {
            var t, e = e ? e.ownerDocument || e : y;
            return e != C && 9 === e.nodeType && e.documentElement && (s = (C = e).documentElement,
            E = !r(C),
            y != C && (t = C.defaultView) && t.top !== t && (t.addEventListener ? t.addEventListener("unload", i, !1) : t.attachEvent && t.attachEvent("onunload", i)),
            p.scope = ce(function(e) {
                return s.appendChild(e).appendChild(C.createElement("div")),
                void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
            }),
            p.attributes = ce(function(e) {
                return e.className = "i",
                !e.getAttribute("className")
            }),
            p.getElementsByTagName = ce(function(e) {
                return e.appendChild(C.createComment("")),
                !e.getElementsByTagName("*").length
            }),
            p.getElementsByClassName = ee.test(C.getElementsByClassName),
            p.getById = ce(function(e) {
                return s.appendChild(e).id = S,
                !C.getElementsByName || !C.getElementsByName(S).length
            }),
            p.getById ? (b.filter.ID = function(e) {
                var t = e.replace(ie, f);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }
            ,
            b.find.ID = function(e, t) {
                if (void 0 !== t.getElementById && E) {
                    e = t.getElementById(e);
                    return e ? [e] : []
                }
            }
            ) : (b.filter.ID = function(e) {
                var t = e.replace(ie, f);
                return function(e) {
                    e = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return e && e.value === t
                }
            }
            ,
            b.find.ID = function(e, t) {
                if (void 0 !== t.getElementById && E) {
                    var n, i, r, o = t.getElementById(e);
                    if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                            return [o];
                        for (r = t.getElementsByName(e),
                        i = 0; o = r[i++]; )
                            if ((n = o.getAttributeNode("id")) && n.value === e)
                                return [o]
                    }
                    return []
                }
            }
            ),
            b.find.TAG = p.getElementsByTagName ? function(e, t) {
                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : p.qsa ? t.querySelectorAll(e) : void 0
            }
            : function(e, t) {
                var n, i = [], r = 0, o = t.getElementsByTagName(e);
                if ("*" !== e)
                    return o;
                for (; n = o[r++]; )
                    1 === n.nodeType && i.push(n);
                return i
            }
            ,
            b.find.CLASS = p.getElementsByClassName && function(e, t) {
                if (void 0 !== t.getElementsByClassName && E)
                    return t.getElementsByClassName(e)
            }
            ,
            a = [],
            v = [],
            (p.qsa = ee.test(C.querySelectorAll)) && (ce(function(e) {
                var t;
                s.appendChild(e).innerHTML = "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + R + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length || v.push("\\[" + R + "*(?:value|" + $ + ")"),
                e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="),
                (t = C.createElement("input")).setAttribute("name", ""),
                e.appendChild(t),
                e.querySelectorAll("[name='']").length || v.push("\\[" + R + "*name" + R + "*=" + R + "*(?:''|\"\")"),
                e.querySelectorAll(":checked").length || v.push(":checked"),
                e.querySelectorAll("a#" + S + "+*").length || v.push(".#.+[+~]"),
                e.querySelectorAll("\\\f"),
                v.push("[\\r\\n\\f]")
            }),
            ce(function(e) {
                e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = C.createElement("input");
                t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length && v.push("name" + R + "*[*^$|!~]?="),
                2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"),
                s.appendChild(e).disabled = !0,
                2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                v.push(",.*:")
            })),
            (p.matchesSelector = ee.test(c = s.matches || s.webkitMatchesSelector || s.mozMatchesSelector || s.oMatchesSelector || s.msMatchesSelector)) && ce(function(e) {
                p.disconnectedMatch = c.call(e, "*"),
                c.call(e, "[s!='']:x"),
                a.push("!=", W)
            }),
            v = v.length && new RegExp(v.join("|")),
            a = a.length && new RegExp(a.join("|")),
            t = ee.test(s.compareDocumentPosition),
            m = t || ee.test(s.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e
                  , t = t && t.parentNode;
                return e === t || !(!t || 1 !== t.nodeType || !(n.contains ? n.contains(t) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(t)))
            }
            : function(e, t) {
                if (t)
                    for (; t = t.parentNode; )
                        if (t === e)
                            return !0;
                return !1
            }
            ,
            L = t ? function(e, t) {
                if (e === t)
                    return u = !0,
                    0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !p.sortDetached && t.compareDocumentPosition(e) === n ? e == C || e.ownerDocument == y && m(y, e) ? -1 : t == C || t.ownerDocument == y && m(y, t) ? 1 : l ? M(l, e) - M(l, t) : 0 : 4 & n ? -1 : 1)
            }
            : function(e, t) {
                if (e === t)
                    return u = !0,
                    0;
                var n, i = 0, r = e.parentNode, o = t.parentNode, s = [e], a = [t];
                if (!r || !o)
                    return e == C ? -1 : t == C ? 1 : r ? -1 : o ? 1 : l ? M(l, e) - M(l, t) : 0;
                if (r === o)
                    return de(e, t);
                for (n = e; n = n.parentNode; )
                    s.unshift(n);
                for (n = t; n = n.parentNode; )
                    a.unshift(n);
                for (; s[i] === a[i]; )
                    i++;
                return i ? de(s[i], a[i]) : s[i] == y ? -1 : a[i] == y ? 1 : 0
            }
            ),
            C
        }
        ,
        ae.matches = function(e, t) {
            return ae(e, null, null, t)
        }
        ,
        ae.matchesSelector = function(e, t) {
            if (T(e),
            p.matchesSelector && E && !j[t + " "] && (!a || !a.test(t)) && (!v || !v.test(t)))
                try {
                    var n = c.call(e, t);
                    if (n || p.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                        return n
                } catch (e) {
                    j(t, !0)
                }
            return 0 < ae(t, C, null, [e]).length
        }
        ,
        ae.contains = function(e, t) {
            return (e.ownerDocument || e) != C && T(e),
            m(e, t)
        }
        ,
        ae.attr = function(e, t) {
            (e.ownerDocument || e) != C && T(e);
            var n = b.attrHandle[t.toLowerCase()]
              , n = n && P.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
            return void 0 !== n ? n : p.attributes || !E ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
        }
        ,
        ae.escape = function(e) {
            return (e + "").replace(re, oe)
        }
        ,
        ae.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }
        ,
        ae.uniqueSort = function(e) {
            var t, n = [], i = 0, r = 0;
            if (u = !p.detectDuplicates,
            l = !p.sortStable && e.slice(0),
            e.sort(L),
            u) {
                for (; t = e[r++]; )
                    t === e[r] && (i = n.push(r));
                for (; i--; )
                    e.splice(n[i], 1)
            }
            return l = null,
            e
        }
        ,
        o = ae.getText = function(e) {
            var t, n = "", i = 0, r = e.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof e.textContent)
                        return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling)
                        n += o(e)
                } else if (3 === r || 4 === r)
                    return e.nodeValue
            } else
                for (; t = e[i++]; )
                    n += o(t);
            return n
        }
        ,
        (b = ae.selectors = {
            cacheLength: 50,
            createPseudo: ue,
            match: G,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(ie, f),
                    e[3] = (e[3] || e[4] || e[5] || "").replace(ie, f),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(),
                    "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]),
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                    e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && ae.error(e[0]),
                    e
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return G.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && Q.test(n) && (t = h(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t),
                    e[2] = n.slice(0, t)),
                    e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(ie, f).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    }
                    : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = k[e + " "];
                    return t || (t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) && k(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(t, n, i) {
                    return function(e) {
                        e = ae.attr(e, t);
                        return null == e ? "!=" === n : !n || (e += "",
                        "=" === n ? e === i : "!=" === n ? e !== i : "^=" === n ? i && 0 === e.indexOf(i) : "*=" === n ? i && -1 < e.indexOf(i) : "$=" === n ? i && e.slice(-i.length) === i : "~=" === n ? -1 < (" " + e.replace(B, " ") + " ").indexOf(i) : "|=" === n && (e === i || e.slice(0, i.length + 1) === i + "-"))
                    }
                },
                CHILD: function(h, e, t, g, v) {
                    var m = "nth" !== h.slice(0, 3)
                      , y = "last" !== h.slice(-4)
                      , x = "of-type" === e;
                    return 1 === g && 0 === v ? function(e) {
                        return !!e.parentNode
                    }
                    : function(e, t, n) {
                        var i, r, o, s, a, l, u = m != y ? "nextSibling" : "previousSibling", c = e.parentNode, f = x && e.nodeName.toLowerCase(), d = !n && !x, p = !1;
                        if (c) {
                            if (m) {
                                for (; u; ) {
                                    for (s = e; s = s[u]; )
                                        if (x ? s.nodeName.toLowerCase() === f : 1 === s.nodeType)
                                            return !1;
                                    l = u = "only" === h && !l && "nextSibling"
                                }
                                return !0
                            }
                            if (l = [y ? c.firstChild : c.lastChild],
                            y && d) {
                                for (p = (a = (i = (r = (o = (s = c)[S] || (s[S] = {}))[s.uniqueID] || (o[s.uniqueID] = {}))[h] || [])[0] === N && i[1]) && i[2],
                                s = a && c.childNodes[a]; s = ++a && s && s[u] || (p = a = 0) || l.pop(); )
                                    if (1 === s.nodeType && ++p && s === e) {
                                        r[h] = [N, a, p];
                                        break
                                    }
                            } else if (d && (p = a = (i = (r = (o = (s = e)[S] || (s[S] = {}))[s.uniqueID] || (o[s.uniqueID] = {}))[h] || [])[0] === N && i[1]),
                            !1 === p)
                                for (; (s = ++a && s && s[u] || (p = a = 0) || l.pop()) && ((x ? s.nodeName.toLowerCase() !== f : 1 !== s.nodeType) || !++p || (d && ((r = (o = s[S] || (s[S] = {}))[s.uniqueID] || (o[s.uniqueID] = {}))[h] = [N, p]),
                                s !== e)); )
                                    ;
                            return (p -= v) === g || p % g == 0 && 0 <= p / g
                        }
                    }
                },
                PSEUDO: function(e, o) {
                    var t, s = b.pseudos[e] || b.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                    return s[S] ? s(o) : 1 < s.length ? (t = [e, e, "", o],
                    b.setFilters.hasOwnProperty(e.toLowerCase()) ? ue(function(e, t) {
                        for (var n, i = s(e, o), r = i.length; r--; )
                            e[n = M(e, i[r])] = !(t[n] = i[r])
                    }) : function(e) {
                        return s(e, 0, t)
                    }
                    ) : s
                }
            },
            pseudos: {
                not: ue(function(e) {
                    var i = []
                      , r = []
                      , a = d(e.replace(z, "$1"));
                    return a[S] ? ue(function(e, t, n, i) {
                        for (var r, o = a(e, null, i, []), s = e.length; s--; )
                            (r = o[s]) && (e[s] = !(t[s] = r))
                    }) : function(e, t, n) {
                        return i[0] = e,
                        a(i, null, n, r),
                        i[0] = null,
                        !r.pop()
                    }
                }),
                has: ue(function(t) {
                    return function(e) {
                        return 0 < ae(t, e).length
                    }
                }),
                contains: ue(function(t) {
                    return t = t.replace(ie, f),
                    function(e) {
                        return -1 < (e.textContent || o(e)).indexOf(t)
                    }
                }),
                lang: ue(function(n) {
                    return Y.test(n || "") || ae.error("unsupported lang: " + n),
                    n = n.replace(ie, f).toLowerCase(),
                    function(e) {
                        var t;
                        do {
                            if (t = E ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-")
                        } while ((e = e.parentNode) && 1 === e.nodeType);
                        return !1
                    }
                }),
                target: function(e) {
                    var t = n.location && n.location.hash;
                    return t && t.slice(1) === e.id
                },
                root: function(e) {
                    return e === s
                },
                focus: function(e) {
                    return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: pe(!1),
                disabled: pe(!0),
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex,
                    !0 === e.selected
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(e) {
                    return !b.pseudos.empty(e)
                },
                header: function(e) {
                    return Z.test(e.nodeName)
                },
                input: function(e) {
                    return K.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (e = e.getAttribute("type")) || "text" === e.toLowerCase())
                },
                first: he(function() {
                    return [0]
                }),
                last: he(function(e, t) {
                    return [t - 1]
                }),
                eq: he(function(e, t, n) {
                    return [n < 0 ? n + t : n]
                }),
                even: he(function(e, t) {
                    for (var n = 0; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                odd: he(function(e, t) {
                    for (var n = 1; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                lt: he(function(e, t, n) {
                    for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i; )
                        e.push(i);
                    return e
                }),
                gt: he(function(e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t; )
                        e.push(i);
                    return e
                })
            }
        }).pseudos.nth = b.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            b.pseudos[e] = function(t) {
                return function(e) {
                    return "input" === e.nodeName.toLowerCase() && e.type === t
                }
            }(e);
        for (e in {
            submit: !0,
            reset: !0
        })
            b.pseudos[e] = function(n) {
                return function(e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t || "button" === t) && e.type === n
                }
            }(e);
        function ve() {}
        function me(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++)
                i += e[t].value;
            return i
        }
        function ye(s, e, t) {
            var a = e.dir
              , l = e.next
              , u = l || a
              , c = t && "parentNode" === u
              , f = x++;
            return e.first ? function(e, t, n) {
                for (; e = e[a]; )
                    if (1 === e.nodeType || c)
                        return s(e, t, n);
                return !1
            }
            : function(e, t, n) {
                var i, r, o = [N, f];
                if (n) {
                    for (; e = e[a]; )
                        if ((1 === e.nodeType || c) && s(e, t, n))
                            return !0
                } else
                    for (; e = e[a]; )
                        if (1 === e.nodeType || c)
                            if (i = (r = e[S] || (e[S] = {}))[e.uniqueID] || (r[e.uniqueID] = {}),
                            l && l === e.nodeName.toLowerCase())
                                e = e[a] || e;
                            else {
                                if ((r = i[u]) && r[0] === N && r[1] === f)
                                    return o[2] = r[2];
                                if ((i[u] = o)[2] = s(e, t, n))
                                    return !0
                            }
                return !1
            }
        }
        function xe(r) {
            return 1 < r.length ? function(e, t, n) {
                for (var i = r.length; i--; )
                    if (!r[i](e, t, n))
                        return !1;
                return !0
            }
            : r[0]
        }
        function be(e, t, n, i, r) {
            for (var o, s = [], a = 0, l = e.length, u = null != t; a < l; a++)
                (o = e[a]) && (n && !n(o, i, r) || (s.push(o),
                u && t.push(a)));
            return s
        }
        function we(e) {
            for (var i, t, n, r = e.length, o = b.relative[e[0].type], s = o || b.relative[" "], a = o ? 1 : 0, l = ye(function(e) {
                return e === i
            }, s, !0), u = ye(function(e) {
                return -1 < M(i, e)
            }, s, !0), c = [function(e, t, n) {
                n = !o && (n || t !== w) || ((i = t).nodeType ? l : u)(e, t, n);
                return i = null,
                n
            }
            ]; a < r; a++)
                if (t = b.relative[e[a].type])
                    c = [ye(xe(c), t)];
                else {
                    if ((t = b.filter[e[a].type].apply(null, e[a].matches))[S]) {
                        for (n = ++a; n < r && !b.relative[e[n].type]; n++)
                            ;
                        return function e(p, h, g, v, m, t) {
                            return v && !v[S] && (v = e(v)),
                            m && !m[S] && (m = e(m, t)),
                            ue(function(e, t, n, i) {
                                var r, o, s, a = [], l = [], u = t.length, c = e || function(e, t, n) {
                                    for (var i = 0, r = t.length; i < r; i++)
                                        ae(e, t[i], n);
                                    return n
                                }(h || "*", n.nodeType ? [n] : n, []), f = !p || !e && h ? c : be(c, a, p, n, i), d = g ? m || (e ? p : u || v) ? [] : t : f;
                                if (g && g(f, d, n, i),
                                v)
                                    for (r = be(d, l),
                                    v(r, [], n, i),
                                    o = r.length; o--; )
                                        (s = r[o]) && (d[l[o]] = !(f[l[o]] = s));
                                if (e) {
                                    if (m || p) {
                                        if (m) {
                                            for (r = [],
                                            o = d.length; o--; )
                                                (s = d[o]) && r.push(f[o] = s);
                                            m(null, d = [], r, i)
                                        }
                                        for (o = d.length; o--; )
                                            (s = d[o]) && -1 < (r = m ? M(e, s) : a[o]) && (e[r] = !(t[r] = s))
                                    }
                                } else
                                    d = be(d === t ? d.splice(u, d.length) : d),
                                    m ? m(null, t, d, i) : H.apply(t, d)
                            })
                        }(1 < a && xe(c), 1 < a && me(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(z, "$1"), t, a < n && we(e.slice(a, n)), n < r && we(e = e.slice(n)), n < r && me(e))
                    }
                    c.push(t)
                }
            return xe(c)
        }
        return ve.prototype = b.filters = b.pseudos,
        b.setFilters = new ve,
        h = ae.tokenize = function(e, t) {
            var n, i, r, o, s, a, l, u = A[e + " "];
            if (u)
                return t ? 0 : u.slice(0);
            for (s = e,
            a = [],
            l = b.preFilter; s; ) {
                for (o in n && !(i = V.exec(s)) || (i && (s = s.slice(i[0].length) || s),
                a.push(r = [])),
                n = !1,
                (i = U.exec(s)) && (n = i.shift(),
                r.push({
                    value: n,
                    type: i[0].replace(z, " ")
                }),
                s = s.slice(n.length)),
                b.filter)
                    !(i = G[o].exec(s)) || l[o] && !(i = l[o](i)) || (n = i.shift(),
                    r.push({
                        value: n,
                        type: o,
                        matches: i
                    }),
                    s = s.slice(n.length));
                if (!n)
                    break
            }
            return t ? s.length : s ? ae.error(e) : A(e, a).slice(0)
        }
        ,
        d = ae.compile = function(e, t) {
            var n, v, m, y, x, i, r = [], o = [], s = D[e + " "];
            if (!s) {
                for (n = (t = t || h(e)).length; n--; )
                    ((s = we(t[n]))[S] ? r : o).push(s);
                (s = D(e, (v = o,
                y = 0 < (m = r).length,
                x = 0 < v.length,
                i = function(e, t, n, i, r) {
                    var o, s, a, l = 0, u = "0", c = e && [], f = [], d = w, p = e || x && b.find.TAG("*", r), h = N += null == d ? 1 : Math.random() || .1, g = p.length;
                    for (r && (w = t == C || t || r); u !== g && null != (o = p[u]); u++) {
                        if (x && o) {
                            for (s = 0,
                            t || o.ownerDocument == C || (T(o),
                            n = !E); a = v[s++]; )
                                if (a(o, t || C, n)) {
                                    i.push(o);
                                    break
                                }
                            r && (N = h)
                        }
                        y && ((o = !a && o) && l--,
                        e && c.push(o))
                    }
                    if (l += u,
                    y && u !== l) {
                        for (s = 0; a = m[s++]; )
                            a(c, f, t, n);
                        if (e) {
                            if (0 < l)
                                for (; u--; )
                                    c[u] || f[u] || (f[u] = q.call(i));
                            f = be(f)
                        }
                        H.apply(i, f),
                        r && !e && 0 < f.length && 1 < l + m.length && ae.uniqueSort(i)
                    }
                    return r && (N = h,
                    w = d),
                    c
                }
                ,
                y ? ue(i) : i))).selector = e
            }
            return s
        }
        ,
        g = ae.select = function(e, t, n, i) {
            var r, o, s, a, l, u = "function" == typeof e && e, c = !i && h(e = u.selector || e);
            if (n = n || [],
            1 === c.length) {
                if (2 < (o = c[0] = c[0].slice(0)).length && "ID" === (s = o[0]).type && 9 === t.nodeType && E && b.relative[o[1].type]) {
                    if (!(t = (b.find.ID(s.matches[0].replace(ie, f), t) || [])[0]))
                        return n;
                    u && (t = t.parentNode),
                    e = e.slice(o.shift().value.length)
                }
                for (r = G.needsContext.test(e) ? 0 : o.length; r-- && (s = o[r],
                !b.relative[a = s.type]); )
                    if ((l = b.find[a]) && (i = l(s.matches[0].replace(ie, f), ne.test(o[0].type) && ge(t.parentNode) || t))) {
                        if (o.splice(r, 1),
                        !(e = i.length && me(o)))
                            return H.apply(n, i),
                            n;
                        break
                    }
            }
            return (u || d(e, c))(i, t, !E, n, !t || ne.test(e) && ge(t.parentNode) || t),
            n
        }
        ,
        p.sortStable = S.split("").sort(L).join("") === S,
        p.detectDuplicates = !!u,
        T(),
        p.sortDetached = ce(function(e) {
            return 1 & e.compareDocumentPosition(C.createElement("fieldset"))
        }),
        ce(function(e) {
            return e.innerHTML = "<a href='#'></a>",
            "#" === e.firstChild.getAttribute("href")
        }) || fe("type|href|height|width", function(e, t, n) {
            if (!n)
                return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
        p.attributes && ce(function(e) {
            return e.innerHTML = "<input/>",
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
        }) || fe("value", function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase())
                return e.defaultValue
        }),
        ce(function(e) {
            return null == e.getAttribute("disabled")
        }) || fe($, function(e, t, n) {
            if (!n)
                return !0 === e[t] ? t.toLowerCase() : (t = e.getAttributeNode(t)) && t.specified ? t.value : null
        }),
        ae
    }(C);
    S.find = p,
    S.expr = p.selectors,
    S.expr[":"] = S.expr.pseudos,
    S.uniqueSort = S.unique = p.uniqueSort,
    S.text = p.getText,
    S.isXMLDoc = p.isXML,
    S.contains = p.contains,
    S.escapeSelector = p.escape;
    function w(e, t, n) {
        for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
            if (1 === e.nodeType) {
                if (r && S(e).is(n))
                    break;
                i.push(e)
            }
        return i
    }
    function T(e, t) {
        for (var n = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && n.push(e);
        return n
    }
    var N = S.expr.match.needsContext;
    function k(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function D(e, n, i) {
        return x(n) ? S.grep(e, function(e, t) {
            return !!n.call(e, t, e) !== i
        }) : n.nodeType ? S.grep(e, function(e) {
            return e === n !== i
        }) : "string" != typeof n ? S.grep(e, function(e) {
            return -1 < r.call(n, e) !== i
        }) : S.filter(n, e, i)
    }
    S.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === i.nodeType ? S.find.matchesSelector(i, e) ? [i] : [] : S.find.matches(e, S.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }
    ,
    S.fn.extend({
        find: function(e) {
            var t, n, i = this.length, r = this;
            if ("string" != typeof e)
                return this.pushStack(S(e).filter(function() {
                    for (t = 0; t < i; t++)
                        if (S.contains(r[t], this))
                            return !0
                }));
            for (n = this.pushStack([]),
            t = 0; t < i; t++)
                S.find(e, r[t], n);
            return 1 < i ? S.uniqueSort(n) : n
        },
        filter: function(e) {
            return this.pushStack(D(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(D(this, e || [], !0))
        },
        is: function(e) {
            return !!D(this, "string" == typeof e && N.test(e) ? S(e) : e || [], !1).length
        }
    });
    var j, L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (S.fn.init = function(e, t, n) {
        if (!e)
            return this;
        if (n = n || j,
        "string" != typeof e)
            return e.nodeType ? (this[0] = e,
            this.length = 1,
            this) : x(e) ? void 0 !== n.ready ? n.ready(e) : e(S) : S.makeArray(e, this);
        if (!(i = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : L.exec(e)) || !i[1] && t)
            return (!t || t.jquery ? t || n : this.constructor(t)).find(e);
        if (i[1]) {
            if (t = t instanceof S ? t[0] : t,
            S.merge(this, S.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : E, !0)),
            A.test(i[1]) && S.isPlainObject(t))
                for (var i in t)
                    x(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this
        }
        return (e = E.getElementById(i[2])) && (this[0] = e,
        this.length = 1),
        this
    }
    ).prototype = S.fn,
    j = S(E);
    var P = /^(?:parents|prev(?:Until|All))/
      , q = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    function O(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; )
            ;
        return e
    }
    S.fn.extend({
        has: function(e) {
            var t = S(e, this)
              , n = t.length;
            return this.filter(function() {
                for (var e = 0; e < n; e++)
                    if (S.contains(this, t[e]))
                        return !0
            })
        },
        closest: function(e, t) {
            var n, i = 0, r = this.length, o = [], s = "string" != typeof e && S(e);
            if (!N.test(e))
                for (; i < r; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && S.find.matchesSelector(n, e))) {
                            o.push(n);
                            break
                        }
            return this.pushStack(1 < o.length ? S.uniqueSort(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? r.call(S(e), this[0]) : r.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }),
    S.each({
        parent: function(e) {
            e = e.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(e) {
            return w(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return w(e, "parentNode", n)
        },
        next: function(e) {
            return O(e, "nextSibling")
        },
        prev: function(e) {
            return O(e, "previousSibling")
        },
        nextAll: function(e) {
            return w(e, "nextSibling")
        },
        prevAll: function(e) {
            return w(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return w(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return w(e, "previousSibling", n)
        },
        siblings: function(e) {
            return T((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return T(e.firstChild)
        },
        contents: function(e) {
            return null != e.contentDocument && n(e.contentDocument) ? e.contentDocument : (k(e, "template") && (e = e.content || e),
            S.merge([], e.childNodes))
        }
    }, function(i, r) {
        S.fn[i] = function(e, t) {
            var n = S.map(this, r, e);
            return "Until" !== i.slice(-5) && (t = e),
            t && "string" == typeof t && (n = S.filter(t, n)),
            1 < this.length && (q[i] || S.uniqueSort(n),
            P.test(i) && n.reverse()),
            this.pushStack(n)
        }
    });
    var H = /[^\x20\t\r\n\f]+/g;
    function I(e) {
        return e
    }
    function M(e) {
        throw e
    }
    function $(e, t, n, i) {
        var r;
        try {
            e && x(r = e.promise) ? r.call(e).done(t).fail(n) : e && x(r = e.then) ? r.call(e, t, n) : t.apply(void 0, [e].slice(i))
        } catch (e) {
            n.apply(void 0, [e])
        }
    }
    S.Callbacks = function(i) {
        var n;
        i = "string" == typeof i ? (n = {},
        S.each(i.match(H) || [], function(e, t) {
            n[t] = !0
        }),
        n) : S.extend({}, i);
        function r() {
            for (s = s || i.once,
            t = o = !0; l.length; u = -1)
                for (e = l.shift(); ++u < a.length; )
                    !1 === a[u].apply(e[0], e[1]) && i.stopOnFalse && (u = a.length,
                    e = !1);
            i.memory || (e = !1),
            o = !1,
            s && (a = e ? [] : "")
        }
        var o, e, t, s, a = [], l = [], u = -1, c = {
            add: function() {
                return a && (e && !o && (u = a.length - 1,
                l.push(e)),
                function n(e) {
                    S.each(e, function(e, t) {
                        x(t) ? i.unique && c.has(t) || a.push(t) : t && t.length && "string" !== h(t) && n(t)
                    })
                }(arguments),
                e && !o && r()),
                this
            },
            remove: function() {
                return S.each(arguments, function(e, t) {
                    for (var n; -1 < (n = S.inArray(t, a, n)); )
                        a.splice(n, 1),
                        n <= u && u--
                }),
                this
            },
            has: function(e) {
                return e ? -1 < S.inArray(e, a) : 0 < a.length
            },
            empty: function() {
                return a = a && [],
                this
            },
            disable: function() {
                return s = l = [],
                a = e = "",
                this
            },
            disabled: function() {
                return !a
            },
            lock: function() {
                return s = l = [],
                e || o || (a = e = ""),
                this
            },
            locked: function() {
                return !!s
            },
            fireWith: function(e, t) {
                return s || (t = [e, (t = t || []).slice ? t.slice() : t],
                l.push(t),
                o || r()),
                this
            },
            fire: function() {
                return c.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!t
            }
        };
        return c
    }
    ,
    S.extend({
        Deferred: function(e) {
            var o = [["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2], ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"]]
              , r = "pending"
              , s = {
                state: function() {
                    return r
                },
                always: function() {
                    return a.done(arguments).fail(arguments),
                    this
                },
                catch: function(e) {
                    return s.then(null, e)
                },
                pipe: function() {
                    var r = arguments;
                    return S.Deferred(function(i) {
                        S.each(o, function(e, t) {
                            var n = x(r[t[4]]) && r[t[4]];
                            a[t[1]](function() {
                                var e = n && n.apply(this, arguments);
                                e && x(e.promise) ? e.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[t[0] + "With"](this, n ? [e] : arguments)
                            })
                        }),
                        r = null
                    }).promise()
                },
                then: function(t, n, i) {
                    var l = 0;
                    function u(r, o, s, a) {
                        return function() {
                            function e() {
                                var e, t;
                                if (!(r < l)) {
                                    if ((e = s.apply(n, i)) === o.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    t = e && ("object" == typeof e || "function" == typeof e) && e.then,
                                    x(t) ? a ? t.call(e, u(l, o, I, a), u(l, o, M, a)) : (l++,
                                    t.call(e, u(l, o, I, a), u(l, o, M, a), u(l, o, I, o.notifyWith))) : (s !== I && (n = void 0,
                                    i = [e]),
                                    (a || o.resolveWith)(n, i))
                                }
                            }
                            var n = this
                              , i = arguments
                              , t = a ? e : function() {
                                try {
                                    e()
                                } catch (e) {
                                    S.Deferred.exceptionHook && S.Deferred.exceptionHook(e, t.stackTrace),
                                    l <= r + 1 && (s !== M && (n = void 0,
                                    i = [e]),
                                    o.rejectWith(n, i))
                                }
                            }
                            ;
                            r ? t() : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()),
                            C.setTimeout(t))
                        }
                    }
                    return S.Deferred(function(e) {
                        o[0][3].add(u(0, e, x(i) ? i : I, e.notifyWith)),
                        o[1][3].add(u(0, e, x(t) ? t : I)),
                        o[2][3].add(u(0, e, x(n) ? n : M))
                    }).promise()
                },
                promise: function(e) {
                    return null != e ? S.extend(e, s) : s
                }
            }
              , a = {};
            return S.each(o, function(e, t) {
                var n = t[2]
                  , i = t[5];
                s[t[1]] = n.add,
                i && n.add(function() {
                    r = i
                }, o[3 - e][2].disable, o[3 - e][3].disable, o[0][2].lock, o[0][3].lock),
                n.add(t[3].fire),
                a[t[0]] = function() {
                    return a[t[0] + "With"](this === a ? void 0 : this, arguments),
                    this
                }
                ,
                a[t[0] + "With"] = n.fireWith
            }),
            s.promise(a),
            e && e.call(a, a),
            a
        },
        when: function(e) {
            function t(t) {
                return function(e) {
                    r[t] = this,
                    o[t] = 1 < arguments.length ? a.call(arguments) : e,
                    --n || s.resolveWith(r, o)
                }
            }
            var n = arguments.length
              , i = n
              , r = Array(i)
              , o = a.call(arguments)
              , s = S.Deferred();
            if (n <= 1 && ($(e, s.done(t(i)).resolve, s.reject, !n),
            "pending" === s.state() || x(o[i] && o[i].then)))
                return s.then();
            for (; i--; )
                $(o[i], t(i), s.reject);
            return s.promise()
        }
    });
    var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    S.Deferred.exceptionHook = function(e, t) {
        C.console && C.console.warn && e && R.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
    }
    ,
    S.readyException = function(e) {
        C.setTimeout(function() {
            throw e
        })
    }
    ;
    var _ = S.Deferred();
    function F() {
        E.removeEventListener("DOMContentLoaded", F),
        C.removeEventListener("load", F),
        S.ready()
    }
    S.fn.ready = function(e) {
        return _.then(e).catch(function(e) {
            S.readyException(e)
        }),
        this
    }
    ,
    S.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --S.readyWait : S.isReady) || (S.isReady = !0) !== e && 0 < --S.readyWait || _.resolveWith(E, [S])
        }
    }),
    S.ready.then = _.then,
    "complete" === E.readyState || "loading" !== E.readyState && !E.documentElement.doScroll ? C.setTimeout(S.ready) : (E.addEventListener("DOMContentLoaded", F),
    C.addEventListener("load", F));
    var W = function(e, t, n, i, r, o, s) {
        var a = 0
          , l = e.length
          , u = null == n;
        if ("object" === h(n))
            for (a in r = !0,
            n)
                W(e, t, a, n[a], !0, o, s);
        else if (void 0 !== i && (r = !0,
        x(i) || (s = !0),
        u && (t = s ? (t.call(e, i),
        null) : (u = t,
        function(e, t, n) {
            return u.call(S(e), n)
        }
        )),
        t))
            for (; a < l; a++)
                t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return r ? e : u ? t.call(e) : l ? t(e[0], n) : o
    }
      , B = /^-ms-/
      , z = /-([a-z])/g;
    function V(e, t) {
        return t.toUpperCase()
    }
    function U(e) {
        return e.replace(B, "ms-").replace(z, V)
    }
    function X(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    }
    function Q() {
        this.expando = S.expando + Q.uid++
    }
    Q.uid = 1,
    Q.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {},
            X(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))),
            t
        },
        set: function(e, t, n) {
            var i, r = this.cache(e);
            if ("string" == typeof t)
                r[U(t)] = n;
            else
                for (i in t)
                    r[U(i)] = t[i];
            return r
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][U(t)]
        },
        access: function(e, t, n) {
            return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n),
            void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, i = e[this.expando];
            if (void 0 !== i) {
                if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(U) : (t = U(t))in i ? [t] : t.match(H) || []).length;
                    for (; n--; )
                        delete i[t[n]]
                }
                void 0 !== t && !S.isEmptyObject(i) || (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            e = e[this.expando];
            return void 0 !== e && !S.isEmptyObject(e)
        }
    };
    var Y = new Q
      , G = new Q
      , J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , K = /[A-Z]/g;
    function Z(e, t, n) {
        var i, r;
        if (void 0 === n && 1 === e.nodeType)
            if (i = "data-" + t.replace(K, "-$&").toLowerCase(),
            "string" == typeof (n = e.getAttribute(i))) {
                try {
                    n = "true" === (r = n) || "false" !== r && ("null" === r ? null : r === +r + "" ? +r : J.test(r) ? JSON.parse(r) : r)
                } catch (e) {}
                G.set(e, t, n)
            } else
                n = void 0;
        return n
    }
    S.extend({
        hasData: function(e) {
            return G.hasData(e) || Y.hasData(e)
        },
        data: function(e, t, n) {
            return G.access(e, t, n)
        },
        removeData: function(e, t) {
            G.remove(e, t)
        },
        _data: function(e, t, n) {
            return Y.access(e, t, n)
        },
        _removeData: function(e, t) {
            Y.remove(e, t)
        }
    }),
    S.fn.extend({
        data: function(n, e) {
            var t, i, r, o = this[0], s = o && o.attributes;
            if (void 0 !== n)
                return "object" == typeof n ? this.each(function() {
                    G.set(this, n)
                }) : W(this, function(e) {
                    var t;
                    return o && void 0 === e ? void 0 !== (t = G.get(o, n)) || void 0 !== (t = Z(o, n)) ? t : void 0 : void this.each(function() {
                        G.set(this, n, e)
                    })
                }, null, e, 1 < arguments.length, null, !0);
            if (this.length && (r = G.get(o),
            1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) {
                for (t = s.length; t--; )
                    s[t] && 0 === (i = s[t].name).indexOf("data-") && (i = U(i.slice(5)),
                    Z(o, i, r[i]));
                Y.set(o, "hasDataAttrs", !0)
            }
            return r
        },
        removeData: function(e) {
            return this.each(function() {
                G.remove(this, e)
            })
        }
    }),
    S.extend({
        queue: function(e, t, n) {
            var i;
            if (e)
                return t = (t || "fx") + "queue",
                i = Y.get(e, t),
                n && (!i || Array.isArray(n) ? i = Y.access(e, t, S.makeArray(n)) : i.push(n)),
                i || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = S.queue(e, t)
              , i = n.length
              , r = n.shift()
              , o = S._queueHooks(e, t);
            "inprogress" === r && (r = n.shift(),
            i--),
            r && ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            r.call(e, function() {
                S.dequeue(e, t)
            }, o)),
            !i && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return Y.get(e, n) || Y.access(e, n, {
                empty: S.Callbacks("once memory").add(function() {
                    Y.remove(e, [t + "queue", n])
                })
            })
        }
    }),
    S.fn.extend({
        queue: function(t, n) {
            var e = 2;
            return "string" != typeof t && (n = t,
            t = "fx",
            e--),
            arguments.length < e ? S.queue(this[0], t) : void 0 === n ? this : this.each(function() {
                var e = S.queue(this, t, n);
                S._queueHooks(this, t),
                "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                S.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            function n() {
                --r || o.resolveWith(s, [s])
            }
            var i, r = 1, o = S.Deferred(), s = this, a = this.length;
            for ("string" != typeof e && (t = e,
            e = void 0),
            e = e || "fx"; a--; )
                (i = Y.get(s[a], e + "queueHooks")) && i.empty && (r++,
                i.empty.add(n));
            return n(),
            o.promise(t)
        }
    });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$","i")
      , ne = ["Top", "Right", "Bottom", "Left"]
      , ie = E.documentElement
      , re = function(e) {
        return S.contains(e.ownerDocument, e)
    }
      , oe = {
        composed: !0
    };
    ie.getRootNode && (re = function(e) {
        return S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument
    }
    );
    function se(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && re(e) && "none" === S.css(e, "display")
    }
    function ae(e, t, n, i) {
        var r, o, s = 20, a = i ? function() {
            return i.cur()
        }
        : function() {
            return S.css(e, t, "")
        }
        , l = a(), u = n && n[3] || (S.cssNumber[t] ? "" : "px"), c = e.nodeType && (S.cssNumber[t] || "px" !== u && +l) && te.exec(S.css(e, t));
        if (c && c[3] !== u) {
            for (l /= 2,
            u = u || c[3],
            c = +l || 1; s--; )
                S.style(e, t, c + u),
                (1 - o) * (1 - (o = a() / l || .5)) <= 0 && (s = 0),
                c /= o;
            c *= 2,
            S.style(e, t, c + u),
            n = n || []
        }
        return n && (c = +c || +l || 0,
        r = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
        i && (i.unit = u,
        i.start = c,
        i.end = r)),
        r
    }
    var le = {};
    function ue(e, t) {
        for (var n, i, r, o, s, a, l = [], u = 0, c = e.length; u < c; u++)
            (i = e[u]).style && (n = i.style.display,
            t ? ("none" === n && (l[u] = Y.get(i, "display") || null,
            l[u] || (i.style.display = "")),
            "" === i.style.display && se(i) && (l[u] = (a = o = r = void 0,
            o = i.ownerDocument,
            s = i.nodeName,
            (a = le[s]) || (r = o.body.appendChild(o.createElement(s)),
            a = S.css(r, "display"),
            r.parentNode.removeChild(r),
            "none" === a && (a = "block"),
            le[s] = a)))) : "none" !== n && (l[u] = "none",
            Y.set(i, "display", n)));
        for (u = 0; u < c; u++)
            null != l[u] && (e[u].style.display = l[u]);
        return e
    }
    S.fn.extend({
        show: function() {
            return ue(this, !0)
        },
        hide: function() {
            return ue(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                se(this) ? S(this).show() : S(this).hide()
            })
        }
    });
    var ce = /^(?:checkbox|radio)$/i
      , fe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i
      , de = /^$|^module$|\/(?:java|ecma)script/i
      , f = E.createDocumentFragment().appendChild(E.createElement("div"));
    (p = E.createElement("input")).setAttribute("type", "radio"),
    p.setAttribute("checked", "checked"),
    p.setAttribute("name", "t"),
    f.appendChild(p),
    y.checkClone = f.cloneNode(!0).cloneNode(!0).lastChild.checked,
    f.innerHTML = "<textarea>x</textarea>",
    y.noCloneChecked = !!f.cloneNode(!0).lastChild.defaultValue,
    f.innerHTML = "<option></option>",
    y.option = !!f.lastChild;
    var pe = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    function he(e, t) {
        var n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
        return void 0 === t || t && k(e, t) ? S.merge([e], n) : n
    }
    function ge(e, t) {
        for (var n = 0, i = e.length; n < i; n++)
            Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"))
    }
    pe.tbody = pe.tfoot = pe.colgroup = pe.caption = pe.thead,
    pe.th = pe.td,
    y.option || (pe.optgroup = pe.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ve = /<|&#?\w+;/;
    function me(e, t, n, i, r) {
        for (var o, s, a, l, u, c = t.createDocumentFragment(), f = [], d = 0, p = e.length; d < p; d++)
            if ((o = e[d]) || 0 === o)
                if ("object" === h(o))
                    S.merge(f, o.nodeType ? [o] : o);
                else if (ve.test(o)) {
                    for (s = s || c.appendChild(t.createElement("div")),
                    a = (fe.exec(o) || ["", ""])[1].toLowerCase(),
                    a = pe[a] || pe._default,
                    s.innerHTML = a[1] + S.htmlPrefilter(o) + a[2],
                    u = a[0]; u--; )
                        s = s.lastChild;
                    S.merge(f, s.childNodes),
                    (s = c.firstChild).textContent = ""
                } else
                    f.push(t.createTextNode(o));
        for (c.textContent = "",
        d = 0; o = f[d++]; )
            if (i && -1 < S.inArray(o, i))
                r && r.push(o);
            else if (l = re(o),
            s = he(c.appendChild(o), "script"),
            l && ge(s),
            n)
                for (u = 0; o = s[u++]; )
                    de.test(o.type || "") && n.push(o);
        return c
    }
    var ye = /^([^.]*)(?:\.(.+)|)/;
    function xe() {
        return !0
    }
    function be() {
        return !1
    }
    function we(e, t) {
        return e === function() {
            try {
                return E.activeElement
            } catch (e) {}
        }() == ("focus" === t)
    }
    function Te(e, t, n, i, r, o) {
        var s, a;
        if ("object" == typeof t) {
            for (a in "string" != typeof n && (i = i || n,
            n = void 0),
            t)
                Te(e, a, n, i, t[a], o);
            return e
        }
        if (null == i && null == r ? (r = n,
        i = n = void 0) : null == r && ("string" == typeof n ? (r = i,
        i = void 0) : (r = i,
        i = n,
        n = void 0)),
        !1 === r)
            r = be;
        else if (!r)
            return e;
        return 1 === o && (s = r,
        (r = function(e) {
            return S().off(e),
            s.apply(this, arguments)
        }
        ).guid = s.guid || (s.guid = S.guid++)),
        e.each(function() {
            S.event.add(this, t, r, i, n)
        })
    }
    function Ce(e, r, o) {
        o ? (Y.set(e, r, !1),
        S.event.add(e, r, {
            namespace: !1,
            handler: function(e) {
                var t, n, i = Y.get(this, r);
                if (1 & e.isTrigger && this[r]) {
                    if (i.length)
                        (S.event.special[r] || {}).delegateType && e.stopPropagation();
                    else if (i = a.call(arguments),
                    Y.set(this, r, i),
                    t = o(this, r),
                    this[r](),
                    i !== (n = Y.get(this, r)) || t ? Y.set(this, r, !1) : n = {},
                    i !== n)
                        return e.stopImmediatePropagation(),
                        e.preventDefault(),
                        n && n.value
                } else
                    i.length && (Y.set(this, r, {
                        value: S.event.trigger(S.extend(i[0], S.Event.prototype), i.slice(1), this)
                    }),
                    e.stopImmediatePropagation())
            }
        })) : void 0 === Y.get(e, r) && S.event.add(e, r, xe)
    }
    S.event = {
        global: {},
        add: function(t, e, n, i, r) {
            var o, s, a, l, u, c, f, d, p, h = Y.get(t);
            if (X(t))
                for (n.handler && (n = (o = n).handler,
                r = o.selector),
                r && S.find.matchesSelector(ie, r),
                n.guid || (n.guid = S.guid++),
                (a = h.events) || (a = h.events = Object.create(null)),
                (s = h.handle) || (s = h.handle = function(e) {
                    return void 0 !== S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                l = (e = (e || "").match(H) || [""]).length; l--; )
                    f = p = (u = ye.exec(e[l]) || [])[1],
                    d = (u[2] || "").split(".").sort(),
                    f && (c = S.event.special[f] || {},
                    f = (r ? c.delegateType : c.bindType) || f,
                    c = S.event.special[f] || {},
                    u = S.extend({
                        type: f,
                        origType: p,
                        data: i,
                        handler: n,
                        guid: n.guid,
                        selector: r,
                        needsContext: r && S.expr.match.needsContext.test(r),
                        namespace: d.join(".")
                    }, o),
                    (p = a[f]) || ((p = a[f] = []).delegateCount = 0,
                    c.setup && !1 !== c.setup.call(t, i, d, s) || t.addEventListener && t.addEventListener(f, s)),
                    c.add && (c.add.call(t, u),
                    u.handler.guid || (u.handler.guid = n.guid)),
                    r ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                    S.event.global[f] = !0)
        },
        remove: function(e, t, n, i, r) {
            var o, s, a, l, u, c, f, d, p, h, g, v = Y.hasData(e) && Y.get(e);
            if (v && (l = v.events)) {
                for (u = (t = (t || "").match(H) || [""]).length; u--; )
                    if (p = g = (a = ye.exec(t[u]) || [])[1],
                    h = (a[2] || "").split(".").sort(),
                    p) {
                        for (f = S.event.special[p] || {},
                        d = l[p = (i ? f.delegateType : f.bindType) || p] || [],
                        a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        s = o = d.length; o--; )
                            c = d[o],
                            !r && g !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (d.splice(o, 1),
                            c.selector && d.delegateCount--,
                            f.remove && f.remove.call(e, c));
                        s && !d.length && (f.teardown && !1 !== f.teardown.call(e, h, v.handle) || S.removeEvent(e, p, v.handle),
                        delete l[p])
                    } else
                        for (p in l)
                            S.event.remove(e, p + t[u], n, i, !0);
                S.isEmptyObject(l) && Y.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, n, i, r, o, s = new Array(arguments.length), a = S.event.fix(e), l = (Y.get(this, "events") || Object.create(null))[a.type] || [], e = S.event.special[a.type] || {};
            for (s[0] = a,
            t = 1; t < arguments.length; t++)
                s[t] = arguments[t];
            if (a.delegateTarget = this,
            !e.preDispatch || !1 !== e.preDispatch.call(this, a)) {
                for (o = S.event.handlers.call(this, a, l),
                t = 0; (i = o[t++]) && !a.isPropagationStopped(); )
                    for (a.currentTarget = i.elem,
                    n = 0; (r = i.handlers[n++]) && !a.isImmediatePropagationStopped(); )
                        a.rnamespace && !1 !== r.namespace && !a.rnamespace.test(r.namespace) || (a.handleObj = r,
                        a.data = r.data,
                        void 0 !== (r = ((S.event.special[r.origType] || {}).handle || r.handler).apply(i.elem, s)) && !1 === (a.result = r) && (a.preventDefault(),
                        a.stopPropagation()));
                return e.postDispatch && e.postDispatch.call(this, a),
                a.result
            }
        },
        handlers: function(e, t) {
            var n, i, r, o, s, a = [], l = t.delegateCount, u = e.target;
            if (l && u.nodeType && !("click" === e.type && 1 <= e.button))
                for (; u !== this; u = u.parentNode || this)
                    if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
                        for (o = [],
                        s = {},
                        n = 0; n < l; n++)
                            void 0 === s[r = (i = t[n]).selector + " "] && (s[r] = i.needsContext ? -1 < S(r, this).index(u) : S.find(r, this, null, [u]).length),
                            s[r] && o.push(i);
                        o.length && a.push({
                            elem: u,
                            handlers: o
                        })
                    }
            return u = this,
            l < t.length && a.push({
                elem: u,
                handlers: t.slice(l)
            }),
            a
        },
        addProp: function(t, e) {
            Object.defineProperty(S.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: x(e) ? function() {
                    if (this.originalEvent)
                        return e(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[t]
                }
                ,
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(e) {
            return e[S.expando] ? e : new S.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(e) {
                    e = this || e;
                    return ce.test(e.type) && e.click && k(e, "input") && Ce(e, "click", xe),
                    !1
                },
                trigger: function(e) {
                    e = this || e;
                    return ce.test(e.type) && e.click && k(e, "input") && Ce(e, "click"),
                    !0
                },
                _default: function(e) {
                    e = e.target;
                    return ce.test(e.type) && e.click && k(e, "input") && Y.get(e, "click") || k(e, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    },
    S.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }
    ,
    S.Event = function(e, t) {
        if (!(this instanceof S.Event))
            return new S.Event(e,t);
        e && e.type ? (this.originalEvent = e,
        this.type = e.type,
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? xe : be,
        this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
        this.currentTarget = e.currentTarget,
        this.relatedTarget = e.relatedTarget) : this.type = e,
        t && S.extend(this, t),
        this.timeStamp = e && e.timeStamp || Date.now(),
        this[S.expando] = !0
    }
    ,
    S.Event.prototype = {
        constructor: S.Event,
        isDefaultPrevented: be,
        isPropagationStopped: be,
        isImmediatePropagationStopped: be,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = xe,
            e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = xe,
            e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = xe,
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    S.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0
    }, S.event.addProp),
    S.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        S.event.special[e] = {
            setup: function() {
                return Ce(this, e, we),
                !1
            },
            trigger: function() {
                return Ce(this, e),
                !0
            },
            _default: function() {
                return !0
            },
            delegateType: t
        }
    }),
    S.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, r) {
        S.event.special[e] = {
            delegateType: r,
            bindType: r,
            handle: function(e) {
                var t, n = e.relatedTarget, i = e.handleObj;
                return n && (n === this || S.contains(this, n)) || (e.type = i.origType,
                t = i.handler.apply(this, arguments),
                e.type = r),
                t
            }
        }
    }),
    S.fn.extend({
        on: function(e, t, n, i) {
            return Te(this, e, t, n, i)
        },
        one: function(e, t, n, i) {
            return Te(this, e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj)
                return i = e.handleObj,
                S(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler),
                this;
            if ("object" != typeof e)
                return !1 !== t && "function" != typeof t || (n = t,
                t = void 0),
                !1 === n && (n = be),
                this.each(function() {
                    S.event.remove(this, e, n, t)
                });
            for (r in e)
                this.off(r, t, e[r]);
            return this
        }
    });
    var Ee = /<script|<style|<link/i
      , Se = /checked\s*(?:[^=]|=\s*.checked.)/i
      , Ne = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function ke(e, t) {
        return k(e, "table") && k(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0] || e
    }
    function Ae(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
        e
    }
    function De(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
        e
    }
    function je(e, t) {
        var n, i, r, o;
        if (1 === t.nodeType) {
            if (Y.hasData(e) && (o = Y.get(e).events))
                for (r in Y.remove(t, "handle events"),
                o)
                    for (n = 0,
                    i = o[r].length; n < i; n++)
                        S.event.add(t, r, o[r][n]);
            G.hasData(e) && (e = G.access(e),
            e = S.extend({}, e),
            G.set(t, e))
        }
    }
    function Le(n, i, r, o) {
        i = v(i);
        var e, t, s, a, l, u, c = 0, f = n.length, d = f - 1, p = i[0], h = x(p);
        if (h || 1 < f && "string" == typeof p && !y.checkClone && Se.test(p))
            return n.each(function(e) {
                var t = n.eq(e);
                h && (i[0] = p.call(this, e, t.html())),
                Le(t, i, r, o)
            });
        if (f && (t = (e = me(i, n[0].ownerDocument, !1, n, o)).firstChild,
        1 === e.childNodes.length && (e = t),
        t || o)) {
            for (a = (s = S.map(he(e, "script"), Ae)).length; c < f; c++)
                l = e,
                c !== d && (l = S.clone(l, !0, !0),
                a && S.merge(s, he(l, "script"))),
                r.call(n[c], l, c);
            if (a)
                for (u = s[s.length - 1].ownerDocument,
                S.map(s, De),
                c = 0; c < a; c++)
                    l = s[c],
                    de.test(l.type || "") && !Y.access(l, "globalEval") && S.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? S._evalUrl && !l.noModule && S._evalUrl(l.src, {
                        nonce: l.nonce || l.getAttribute("nonce")
                    }, u) : b(l.textContent.replace(Ne, ""), l, u))
        }
        return n
    }
    function Pe(e, t, n) {
        for (var i, r = t ? S.filter(t, e) : e, o = 0; null != (i = r[o]); o++)
            n || 1 !== i.nodeType || S.cleanData(he(i)),
            i.parentNode && (n && re(i) && ge(he(i, "script")),
            i.parentNode.removeChild(i));
        return e
    }
    S.extend({
        htmlPrefilter: function(e) {
            return e
        },
        clone: function(e, t, n) {
            var i, r, o, s, a, l, u, c = e.cloneNode(!0), f = re(e);
            if (!(y.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || S.isXMLDoc(e)))
                for (s = he(c),
                i = 0,
                r = (o = he(e)).length; i < r; i++)
                    a = o[i],
                    "input" === (u = (l = s[i]).nodeName.toLowerCase()) && ce.test(a.type) ? l.checked = a.checked : "input" !== u && "textarea" !== u || (l.defaultValue = a.defaultValue);
            if (t)
                if (n)
                    for (o = o || he(e),
                    s = s || he(c),
                    i = 0,
                    r = o.length; i < r; i++)
                        je(o[i], s[i]);
                else
                    je(e, c);
            return 0 < (s = he(c, "script")).length && ge(s, !f && he(e, "script")),
            c
        },
        cleanData: function(e) {
            for (var t, n, i, r = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (X(n)) {
                    if (t = n[Y.expando]) {
                        if (t.events)
                            for (i in t.events)
                                r[i] ? S.event.remove(n, i) : S.removeEvent(n, i, t.handle);
                        n[Y.expando] = void 0
                    }
                    n[G.expando] && (n[G.expando] = void 0)
                }
        }
    }),
    S.fn.extend({
        detach: function(e) {
            return Pe(this, e, !0)
        },
        remove: function(e) {
            return Pe(this, e)
        },
        text: function(e) {
            return W(this, function(e) {
                return void 0 === e ? S.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return Le(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || ke(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return Le(this, arguments, function(e) {
                var t;
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (t = ke(this, e)).insertBefore(e, t.firstChild)
            })
        },
        before: function() {
            return Le(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return Le(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (S.cleanData(he(e, !1)),
                e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e,
            t = null == t ? e : t,
            this.map(function() {
                return S.clone(this, e, t)
            })
        },
        html: function(e) {
            return W(this, function(e) {
                var t = this[0] || {}
                  , n = 0
                  , i = this.length;
                if (void 0 === e && 1 === t.nodeType)
                    return t.innerHTML;
                if ("string" == typeof e && !Ee.test(e) && !pe[(fe.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = S.htmlPrefilter(e);
                    try {
                        for (; n < i; n++)
                            1 === (t = this[n] || {}).nodeType && (S.cleanData(he(t, !1)),
                            t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var n = [];
            return Le(this, arguments, function(e) {
                var t = this.parentNode;
                S.inArray(this, n) < 0 && (S.cleanData(he(this)),
                t && t.replaceChild(e, this))
            }, n)
        }
    }),
    S.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, s) {
        S.fn[e] = function(e) {
            for (var t, n = [], i = S(e), r = i.length - 1, o = 0; o <= r; o++)
                t = o === r ? this : this.clone(!0),
                S(i[o])[s](t),
                l.apply(n, t.get());
            return this.pushStack(n)
        }
    });
    function qe(e, t, n) {
        var i, r = {};
        for (i in t)
            r[i] = e.style[i],
            e.style[i] = t[i];
        for (i in n = n.call(e),
        t)
            e.style[i] = r[i];
        return n
    }
    var Oe, He, Ie, Me, $e, Re, _e, Fe, We = new RegExp("^(" + ee + ")(?!px)[a-z%]+$","i"), Be = function(e) {
        var t = e.ownerDocument.defaultView;
        return t && t.opener || (t = C),
        t.getComputedStyle(e)
    }, ze = new RegExp(ne.join("|"),"i");
    function Ve(e, t, n) {
        var i, r, o = e.style;
        return (n = n || Be(e)) && ("" !== (r = n.getPropertyValue(t) || n[t]) || re(e) || (r = S.style(e, t)),
        !y.pixelBoxStyles() && We.test(r) && ze.test(t) && (i = o.width,
        e = o.minWidth,
        t = o.maxWidth,
        o.minWidth = o.maxWidth = o.width = r,
        r = n.width,
        o.width = i,
        o.minWidth = e,
        o.maxWidth = t)),
        void 0 !== r ? r + "" : r
    }
    function Ue(e, t) {
        return {
            get: function() {
                if (!e())
                    return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }
    function Xe() {
        var e;
        Fe && (_e.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
        Fe.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
        ie.appendChild(_e).appendChild(Fe),
        e = C.getComputedStyle(Fe),
        Oe = "1%" !== e.top,
        Re = 12 === Qe(e.marginLeft),
        Fe.style.right = "60%",
        Me = 36 === Qe(e.right),
        He = 36 === Qe(e.width),
        Fe.style.position = "absolute",
        Ie = 12 === Qe(Fe.offsetWidth / 3),
        ie.removeChild(_e),
        Fe = null)
    }
    function Qe(e) {
        return Math.round(parseFloat(e))
    }
    _e = E.createElement("div"),
    (Fe = E.createElement("div")).style && (Fe.style.backgroundClip = "content-box",
    Fe.cloneNode(!0).style.backgroundClip = "",
    y.clearCloneStyle = "content-box" === Fe.style.backgroundClip,
    S.extend(y, {
        boxSizingReliable: function() {
            return Xe(),
            He
        },
        pixelBoxStyles: function() {
            return Xe(),
            Me
        },
        pixelPosition: function() {
            return Xe(),
            Oe
        },
        reliableMarginLeft: function() {
            return Xe(),
            Re
        },
        scrollboxSize: function() {
            return Xe(),
            Ie
        },
        reliableTrDimensions: function() {
            var e, t, n;
            return null == $e && (e = E.createElement("table"),
            t = E.createElement("tr"),
            n = E.createElement("div"),
            e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate",
            t.style.cssText = "border:1px solid",
            t.style.height = "1px",
            n.style.height = "9px",
            n.style.display = "block",
            ie.appendChild(e).appendChild(t).appendChild(n),
            n = C.getComputedStyle(t),
            $e = parseInt(n.height, 10) + parseInt(n.borderTopWidth, 10) + parseInt(n.borderBottomWidth, 10) === t.offsetHeight,
            ie.removeChild(e)),
            $e
        }
    }));
    var Ye = ["Webkit", "Moz", "ms"]
      , Ge = E.createElement("div").style
      , Je = {};
    function Ke(e) {
        return S.cssProps[e] || Je[e] || (e in Ge ? e : Je[e] = function(e) {
            for (var t = e[0].toUpperCase() + e.slice(1), n = Ye.length; n--; )
                if ((e = Ye[n] + t)in Ge)
                    return e
        }(e) || e)
    }
    var Ze = /^(none|table(?!-c[ea]).+)/
      , et = /^--/
      , tt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , nt = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function it(e, t, n) {
        var i = te.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
    }
    function rt(e, t, n, i, r, o) {
        var s = "width" === t ? 1 : 0
          , a = 0
          , l = 0;
        if (n === (i ? "border" : "content"))
            return 0;
        for (; s < 4; s += 2)
            "margin" === n && (l += S.css(e, n + ne[s], !0, r)),
            i ? ("content" === n && (l -= S.css(e, "padding" + ne[s], !0, r)),
            "margin" !== n && (l -= S.css(e, "border" + ne[s] + "Width", !0, r))) : (l += S.css(e, "padding" + ne[s], !0, r),
            "padding" !== n ? l += S.css(e, "border" + ne[s] + "Width", !0, r) : a += S.css(e, "border" + ne[s] + "Width", !0, r));
        return !i && 0 <= o && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - a - .5)) || 0),
        l
    }
    function ot(e, t, n) {
        var i = Be(e)
          , r = (!y.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, i)
          , o = r
          , s = Ve(e, t, i)
          , a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (We.test(s)) {
            if (!n)
                return s;
            s = "auto"
        }
        return (!y.boxSizingReliable() && r || !y.reliableTrDimensions() && k(e, "tr") || "auto" === s || !parseFloat(s) && "inline" === S.css(e, "display", !1, i)) && e.getClientRects().length && (r = "border-box" === S.css(e, "boxSizing", !1, i),
        (o = a in e) && (s = e[a])),
        (s = parseFloat(s) || 0) + rt(e, t, n || (r ? "border" : "content"), o, i, s) + "px"
    }
    function st(e, t, n, i, r) {
        return new st.prototype.init(e,t,n,i,r)
    }
    S.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        e = Ve(e, "opacity");
                        return "" === e ? "1" : e
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, o, s, a = U(t), l = et.test(t), u = e.style;
                if (l || (t = Ke(a)),
                s = S.cssHooks[t] || S.cssHooks[a],
                void 0 === n)
                    return s && "get"in s && void 0 !== (r = s.get(e, !1, i)) ? r : u[t];
                "string" == (o = typeof n) && (r = te.exec(n)) && r[1] && (n = ae(e, t, r),
                o = "number"),
                null != n && n == n && ("number" !== o || l || (n += r && r[3] || (S.cssNumber[a] ? "" : "px")),
                y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"),
                s && "set"in s && void 0 === (n = s.set(e, n, i)) || (l ? u.setProperty(t, n) : u[t] = n))
            }
        },
        css: function(e, t, n, i) {
            var r, o = U(t);
            return et.test(t) || (t = Ke(o)),
            (o = S.cssHooks[t] || S.cssHooks[o]) && "get"in o && (r = o.get(e, !0, n)),
            void 0 === r && (r = Ve(e, t, i)),
            "normal" === r && t in nt && (r = nt[t]),
            "" === n || n ? (t = parseFloat(r),
            !0 === n || isFinite(t) ? t || 0 : r) : r
        }
    }),
    S.each(["height", "width"], function(e, a) {
        S.cssHooks[a] = {
            get: function(e, t, n) {
                if (t)
                    return !Ze.test(S.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ot(e, a, n) : qe(e, tt, function() {
                        return ot(e, a, n)
                    })
            },
            set: function(e, t, n) {
                var i, r = Be(e), o = !y.scrollboxSize() && "absolute" === r.position, s = (o || n) && "border-box" === S.css(e, "boxSizing", !1, r), n = n ? rt(e, a, n, s, r) : 0;
                return s && o && (n -= Math.ceil(e["offset" + a[0].toUpperCase() + a.slice(1)] - parseFloat(r[a]) - rt(e, a, "border", !1, r) - .5)),
                n && (i = te.exec(t)) && "px" !== (i[3] || "px") && (e.style[a] = t,
                t = S.css(e, a)),
                it(0, t, n)
            }
        }
    }),
    S.cssHooks.marginLeft = Ue(y.reliableMarginLeft, function(e, t) {
        if (t)
            return (parseFloat(Ve(e, "marginLeft")) || e.getBoundingClientRect().left - qe(e, {
                marginLeft: 0
            }, function() {
                return e.getBoundingClientRect().left
            })) + "px"
    }),
    S.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(r, o) {
        S.cssHooks[r + o] = {
            expand: function(e) {
                for (var t = 0, n = {}, i = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++)
                    n[r + ne[t] + o] = i[t] || i[t - 2] || i[0];
                return n
            }
        },
        "margin" !== r && (S.cssHooks[r + o].set = it)
    }),
    S.fn.extend({
        css: function(e, t) {
            return W(this, function(e, t, n) {
                var i, r, o = {}, s = 0;
                if (Array.isArray(t)) {
                    for (i = Be(e),
                    r = t.length; s < r; s++)
                        o[t[s]] = S.css(e, t[s], !1, i);
                    return o
                }
                return void 0 !== n ? S.style(e, t, n) : S.css(e, t)
            }, e, t, 1 < arguments.length)
        }
    }),
    ((S.Tween = st).prototype = {
        constructor: st,
        init: function(e, t, n, i, r, o) {
            this.elem = e,
            this.prop = n,
            this.easing = r || S.easing._default,
            this.options = t,
            this.start = this.now = this.cur(),
            this.end = i,
            this.unit = o || (S.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = st.propHooks[this.prop];
            return (e && e.get ? e : st.propHooks._default).get(this)
        },
        run: function(e) {
            var t, n = st.propHooks[this.prop];
            return this.options.duration ? this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
            this.now = (this.end - this.start) * t + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            (n && n.set ? n : st.propHooks._default).set(this),
            this
        }
    }).init.prototype = st.prototype,
    (st.propHooks = {
        _default: {
            get: function(e) {
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (e = S.css(e.elem, e.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(e) {
                S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !S.cssHooks[e.prop] && null == e.elem.style[Ke(e.prop)] ? e.elem[e.prop] = e.now : S.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }).scrollTop = st.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    },
    S.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    },
    S.fx = st.prototype.init,
    S.fx.step = {};
    var at, lt, ut = /^(?:toggle|show|hide)$/, ct = /queueHooks$/;
    function ft() {
        lt && (!1 === E.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(ft) : C.setTimeout(ft, S.fx.interval),
        S.fx.tick())
    }
    function dt() {
        return C.setTimeout(function() {
            at = void 0
        }),
        at = Date.now()
    }
    function pt(e, t) {
        var n, i = 0, r = {
            height: e
        };
        for (t = t ? 1 : 0; i < 4; i += 2 - t)
            r["margin" + (n = ne[i])] = r["padding" + n] = e;
        return t && (r.opacity = r.width = e),
        r
    }
    function ht(e, t, n) {
        for (var i, r = (gt.tweeners[t] || []).concat(gt.tweeners["*"]), o = 0, s = r.length; o < s; o++)
            if (i = r[o].call(n, t, e))
                return i
    }
    function gt(r, e, t) {
        var n, o, i = 0, s = gt.prefilters.length, a = S.Deferred().always(function() {
            delete l.elem
        }), l = function() {
            if (o)
                return !1;
            for (var e = at || dt(), e = Math.max(0, u.startTime + u.duration - e), t = 1 - (e / u.duration || 0), n = 0, i = u.tweens.length; n < i; n++)
                u.tweens[n].run(t);
            return a.notifyWith(r, [u, t, e]),
            t < 1 && i ? e : (i || a.notifyWith(r, [u, 1, 0]),
            a.resolveWith(r, [u]),
            !1)
        }, u = a.promise({
            elem: r,
            props: S.extend({}, e),
            opts: S.extend(!0, {
                specialEasing: {},
                easing: S.easing._default
            }, t),
            originalProperties: e,
            originalOptions: t,
            startTime: at || dt(),
            duration: t.duration,
            tweens: [],
            createTween: function(e, t) {
                e = S.Tween(r, u.opts, e, t, u.opts.specialEasing[e] || u.opts.easing);
                return u.tweens.push(e),
                e
            },
            stop: function(e) {
                var t = 0
                  , n = e ? u.tweens.length : 0;
                if (o)
                    return this;
                for (o = !0; t < n; t++)
                    u.tweens[t].run(1);
                return e ? (a.notifyWith(r, [u, 1, 0]),
                a.resolveWith(r, [u, e])) : a.rejectWith(r, [u, e]),
                this
            }
        }), c = u.props;
        for (function(e, t) {
            var n, i, r, o, s;
            for (n in e)
                if (r = t[i = U(n)],
                o = e[n],
                Array.isArray(o) && (r = o[1],
                o = e[n] = o[0]),
                n !== i && (e[i] = o,
                delete e[n]),
                (s = S.cssHooks[i]) && "expand"in s)
                    for (n in o = s.expand(o),
                    delete e[i],
                    o)
                        n in e || (e[n] = o[n],
                        t[n] = r);
                else
                    t[i] = r
        }(c, u.opts.specialEasing); i < s; i++)
            if (n = gt.prefilters[i].call(u, r, c, u.opts))
                return x(n.stop) && (S._queueHooks(u.elem, u.opts.queue).stop = n.stop.bind(n)),
                n;
        return S.map(c, ht, u),
        x(u.opts.start) && u.opts.start.call(r, u),
        u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
        S.fx.timer(S.extend(l, {
            elem: r,
            anim: u,
            queue: u.opts.queue
        })),
        u
    }
    S.Animation = S.extend(gt, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return ae(n.elem, e, te.exec(t), n),
                n
            }
            ]
        },
        tweener: function(e, t) {
            for (var n, i = 0, r = (e = x(e) ? (t = e,
            ["*"]) : e.match(H)).length; i < r; i++)
                n = e[i],
                gt.tweeners[n] = gt.tweeners[n] || [],
                gt.tweeners[n].unshift(t)
        },
        prefilters: [function(e, t, n) {
            var i, r, o, s, a, l, u, c = "width"in t || "height"in t, f = this, d = {}, p = e.style, h = e.nodeType && se(e), g = Y.get(e, "fxshow");
            for (i in n.queue || (null == (s = S._queueHooks(e, "fx")).unqueued && (s.unqueued = 0,
            a = s.empty.fire,
            s.empty.fire = function() {
                s.unqueued || a()
            }
            ),
            s.unqueued++,
            f.always(function() {
                f.always(function() {
                    s.unqueued--,
                    S.queue(e, "fx").length || s.empty.fire()
                })
            })),
            t)
                if (r = t[i],
                ut.test(r)) {
                    if (delete t[i],
                    o = o || "toggle" === r,
                    r === (h ? "hide" : "show")) {
                        if ("show" !== r || !g || void 0 === g[i])
                            continue;
                        h = !0
                    }
                    d[i] = g && g[i] || S.style(e, i)
                }
            if ((l = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
                for (i in c && 1 === e.nodeType && (n.overflow = [p.overflow, p.overflowX, p.overflowY],
                null == (u = g && g.display) && (u = Y.get(e, "display")),
                "none" === (c = S.css(e, "display")) && (u ? c = u : (ue([e], !0),
                u = e.style.display || u,
                c = S.css(e, "display"),
                ue([e]))),
                ("inline" === c || "inline-block" === c && null != u) && "none" === S.css(e, "float") && (l || (f.done(function() {
                    p.display = u
                }),
                null == u && (c = p.display,
                u = "none" === c ? "" : c)),
                p.display = "inline-block")),
                n.overflow && (p.overflow = "hidden",
                f.always(function() {
                    p.overflow = n.overflow[0],
                    p.overflowX = n.overflow[1],
                    p.overflowY = n.overflow[2]
                })),
                l = !1,
                d)
                    l || (g ? "hidden"in g && (h = g.hidden) : g = Y.access(e, "fxshow", {
                        display: u
                    }),
                    o && (g.hidden = !h),
                    h && ue([e], !0),
                    f.done(function() {
                        for (i in h || ue([e]),
                        Y.remove(e, "fxshow"),
                        d)
                            S.style(e, i, d[i])
                    })),
                    l = ht(h ? g[i] : 0, i, f),
                    i in g || (g[i] = l.start,
                    h && (l.end = l.start,
                    l.start = 0))
        }
        ],
        prefilter: function(e, t) {
            t ? gt.prefilters.unshift(e) : gt.prefilters.push(e)
        }
    }),
    S.speed = function(e, t, n) {
        var i = e && "object" == typeof e ? S.extend({}, e) : {
            complete: n || !n && t || x(e) && e,
            duration: e,
            easing: n && t || t && !x(t) && t
        };
        return S.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in S.fx.speeds ? i.duration = S.fx.speeds[i.duration] : i.duration = S.fx.speeds._default),
        null != i.queue && !0 !== i.queue || (i.queue = "fx"),
        i.old = i.complete,
        i.complete = function() {
            x(i.old) && i.old.call(this),
            i.queue && S.dequeue(this, i.queue)
        }
        ,
        i
    }
    ,
    S.fn.extend({
        fadeTo: function(e, t, n, i) {
            return this.filter(se).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, i)
        },
        animate: function(t, e, n, i) {
            var r = S.isEmptyObject(t)
              , o = S.speed(e, n, i)
              , i = function() {
                var e = gt(this, S.extend({}, t), o);
                (r || Y.get(this, "finish")) && e.stop(!0)
            };
            return i.finish = i,
            r || !1 === o.queue ? this.each(i) : this.queue(o.queue, i)
        },
        stop: function(r, e, o) {
            function s(e) {
                var t = e.stop;
                delete e.stop,
                t(o)
            }
            return "string" != typeof r && (o = e,
            e = r,
            r = void 0),
            e && this.queue(r || "fx", []),
            this.each(function() {
                var e = !0
                  , t = null != r && r + "queueHooks"
                  , n = S.timers
                  , i = Y.get(this);
                if (t)
                    i[t] && i[t].stop && s(i[t]);
                else
                    for (t in i)
                        i[t] && i[t].stop && ct.test(t) && s(i[t]);
                for (t = n.length; t--; )
                    n[t].elem !== this || null != r && n[t].queue !== r || (n[t].anim.stop(o),
                    e = !1,
                    n.splice(t, 1));
                !e && o || S.dequeue(this, r)
            })
        },
        finish: function(s) {
            return !1 !== s && (s = s || "fx"),
            this.each(function() {
                var e, t = Y.get(this), n = t[s + "queue"], i = t[s + "queueHooks"], r = S.timers, o = n ? n.length : 0;
                for (t.finish = !0,
                S.queue(this, s, []),
                i && i.stop && i.stop.call(this, !0),
                e = r.length; e--; )
                    r[e].elem === this && r[e].queue === s && (r[e].anim.stop(!0),
                    r.splice(e, 1));
                for (e = 0; e < o; e++)
                    n[e] && n[e].finish && n[e].finish.call(this);
                delete t.finish
            })
        }
    }),
    S.each(["toggle", "show", "hide"], function(e, i) {
        var r = S.fn[i];
        S.fn[i] = function(e, t, n) {
            return null == e || "boolean" == typeof e ? r.apply(this, arguments) : this.animate(pt(i, !0), e, t, n)
        }
    }),
    S.each({
        slideDown: pt("show"),
        slideUp: pt("hide"),
        slideToggle: pt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, i) {
        S.fn[e] = function(e, t, n) {
            return this.animate(i, e, t, n)
        }
    }),
    S.timers = [],
    S.fx.tick = function() {
        var e, t = 0, n = S.timers;
        for (at = Date.now(); t < n.length; t++)
            (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || S.fx.stop(),
        at = void 0
    }
    ,
    S.fx.timer = function(e) {
        S.timers.push(e),
        S.fx.start()
    }
    ,
    S.fx.interval = 13,
    S.fx.start = function() {
        lt || (lt = !0,
        ft())
    }
    ,
    S.fx.stop = function() {
        lt = null
    }
    ,
    S.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    S.fn.delay = function(i, e) {
        return i = S.fx && S.fx.speeds[i] || i,
        e = e || "fx",
        this.queue(e, function(e, t) {
            var n = C.setTimeout(e, i);
            t.stop = function() {
                C.clearTimeout(n)
            }
        })
    }
    ,
    f = E.createElement("input"),
    ee = E.createElement("select").appendChild(E.createElement("option")),
    f.type = "checkbox",
    y.checkOn = "" !== f.value,
    y.optSelected = ee.selected,
    (f = E.createElement("input")).value = "t",
    f.type = "radio",
    y.radioValue = "t" === f.value;
    var vt, mt = S.expr.attrHandle;
    S.fn.extend({
        attr: function(e, t) {
            return W(this, S.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each(function() {
                S.removeAttr(this, e)
            })
        }
    }),
    S.extend({
        attr: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return void 0 === e.getAttribute ? S.prop(e, t, n) : (1 === o && S.isXMLDoc(e) || (r = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? vt : void 0)),
                void 0 !== n ? null === n ? void S.removeAttr(e, t) : r && "set"in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""),
                n) : !(r && "get"in r && null !== (i = r.get(e, t))) && null == (i = S.find.attr(e, t)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!y.radioValue && "radio" === t && k(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t),
                        n && (e.value = n),
                        t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, i = 0, r = t && t.match(H);
            if (r && 1 === e.nodeType)
                for (; n = r[i++]; )
                    e.removeAttribute(n)
        }
    }),
    vt = {
        set: function(e, t, n) {
            return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n),
            n
        }
    },
    S.each(S.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var s = mt[t] || S.find.attr;
        mt[t] = function(e, t, n) {
            var i, r, o = t.toLowerCase();
            return n || (r = mt[o],
            mt[o] = i,
            i = null != s(e, t, n) ? o : null,
            mt[o] = r),
            i
        }
    });
    var yt = /^(?:input|select|textarea|button)$/i
      , xt = /^(?:a|area)$/i;
    function bt(e) {
        return (e.match(H) || []).join(" ")
    }
    function wt(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }
    function Tt(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(H) || []
    }
    S.fn.extend({
        prop: function(e, t) {
            return W(this, S.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[S.propFix[e] || e]
            })
        }
    }),
    S.extend({
        prop: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && S.isXMLDoc(e) || (t = S.propFix[t] || t,
                r = S.propHooks[t]),
                void 0 !== n ? r && "set"in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get"in r && null !== (i = r.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = S.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : yt.test(e.nodeName) || xt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    y.optSelected || (S.propHooks.selected = {
        get: function(e) {
            e = e.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex,
            null
        },
        set: function(e) {
            e = e.parentNode;
            e && (e.selectedIndex,
            e.parentNode && e.parentNode.selectedIndex)
        }
    }),
    S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        S.propFix[this.toLowerCase()] = this
    }),
    S.fn.extend({
        addClass: function(t) {
            var e, n, i, r, o, s, a = 0;
            if (x(t))
                return this.each(function(e) {
                    S(this).addClass(t.call(this, e, wt(this)))
                });
            if ((e = Tt(t)).length)
                for (; n = this[a++]; )
                    if (s = wt(n),
                    i = 1 === n.nodeType && " " + bt(s) + " ") {
                        for (o = 0; r = e[o++]; )
                            i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                        s !== (s = bt(i)) && n.setAttribute("class", s)
                    }
            return this
        },
        removeClass: function(t) {
            var e, n, i, r, o, s, a = 0;
            if (x(t))
                return this.each(function(e) {
                    S(this).removeClass(t.call(this, e, wt(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((e = Tt(t)).length)
                for (; n = this[a++]; )
                    if (s = wt(n),
                    i = 1 === n.nodeType && " " + bt(s) + " ") {
                        for (o = 0; r = e[o++]; )
                            for (; -1 < i.indexOf(" " + r + " "); )
                                i = i.replace(" " + r + " ", " ");
                        s !== (s = bt(i)) && n.setAttribute("class", s)
                    }
            return this
        },
        toggleClass: function(r, t) {
            var o = typeof r
              , s = "string" == o || Array.isArray(r);
            return "boolean" == typeof t && s ? t ? this.addClass(r) : this.removeClass(r) : x(r) ? this.each(function(e) {
                S(this).toggleClass(r.call(this, e, wt(this), t), t)
            }) : this.each(function() {
                var e, t, n, i;
                if (s)
                    for (t = 0,
                    n = S(this),
                    i = Tt(r); e = i[t++]; )
                        n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                else
                    void 0 !== r && "boolean" != o || ((e = wt(this)) && Y.set(this, "__className__", e),
                    this.setAttribute && this.setAttribute("class", !e && !1 !== r && Y.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            for (var t, n = 0, i = " " + e + " "; t = this[n++]; )
                if (1 === t.nodeType && -1 < (" " + bt(wt(t)) + " ").indexOf(i))
                    return !0;
            return !1
        }
    });
    var Ct = /\r/g;
    S.fn.extend({
        val: function(t) {
            var n, e, i, r = this[0];
            return arguments.length ? (i = x(t),
            this.each(function(e) {
                1 === this.nodeType && (null == (e = i ? t.call(this, e, S(this).val()) : t) ? e = "" : "number" == typeof e ? e += "" : Array.isArray(e) && (e = S.map(e, function(e) {
                    return null == e ? "" : e + ""
                })),
                (n = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set"in n && void 0 !== n.set(this, e, "value") || (this.value = e))
            })) : r ? (n = S.valHooks[r.type] || S.valHooks[r.nodeName.toLowerCase()]) && "get"in n && void 0 !== (e = n.get(r, "value")) ? e : "string" == typeof (e = r.value) ? e.replace(Ct, "") : null == e ? "" : e : void 0
        }
    }),
    S.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = S.find.attr(e, "value");
                    return null != t ? t : bt(S.text(e))
                }
            },
            select: {
                get: function(e) {
                    for (var t, n = e.options, i = e.selectedIndex, r = "select-one" === e.type, o = r ? null : [], s = r ? i + 1 : n.length, a = i < 0 ? s : r ? i : 0; a < s; a++)
                        if (((t = n[a]).selected || a === i) && !t.disabled && (!t.parentNode.disabled || !k(t.parentNode, "optgroup"))) {
                            if (t = S(t).val(),
                            r)
                                return t;
                            o.push(t)
                        }
                    return o
                },
                set: function(e, t) {
                    for (var n, i, r = e.options, o = S.makeArray(t), s = r.length; s--; )
                        ((i = r[s]).selected = -1 < S.inArray(S.valHooks.option.get(i), o)) && (n = !0);
                    return n || (e.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    S.each(["radio", "checkbox"], function() {
        S.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t))
                    return e.checked = -1 < S.inArray(S(e).val(), t)
            }
        },
        y.checkOn || (S.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        }
        )
    }),
    y.focusin = "onfocusin"in C;
    function Et(e) {
        e.stopPropagation()
    }
    var St = /^(?:focusinfocus|focusoutblur)$/;
    S.extend(S.event, {
        trigger: function(e, t, n, i) {
            var r, o, s, a, l, u, c, f = [n || E], d = m.call(e, "type") ? e.type : e, p = m.call(e, "namespace") ? e.namespace.split(".") : [], h = c = o = n = n || E;
            if (3 !== n.nodeType && 8 !== n.nodeType && !St.test(d + S.event.triggered) && (-1 < d.indexOf(".") && (d = (p = d.split(".")).shift(),
            p.sort()),
            a = d.indexOf(":") < 0 && "on" + d,
            (e = e[S.expando] ? e : new S.Event(d,"object" == typeof e && e)).isTrigger = i ? 2 : 3,
            e.namespace = p.join("."),
            e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            e.result = void 0,
            e.target || (e.target = n),
            t = null == t ? [e] : S.makeArray(t, [e]),
            u = S.event.special[d] || {},
            i || !u.trigger || !1 !== u.trigger.apply(n, t))) {
                if (!i && !u.noBubble && !g(n)) {
                    for (s = u.delegateType || d,
                    St.test(s + d) || (h = h.parentNode); h; h = h.parentNode)
                        f.push(h),
                        o = h;
                    o === (n.ownerDocument || E) && f.push(o.defaultView || o.parentWindow || C)
                }
                for (r = 0; (h = f[r++]) && !e.isPropagationStopped(); )
                    c = h,
                    e.type = 1 < r ? s : u.bindType || d,
                    (l = (Y.get(h, "events") || Object.create(null))[e.type] && Y.get(h, "handle")) && l.apply(h, t),
                    (l = a && h[a]) && l.apply && X(h) && (e.result = l.apply(h, t),
                    !1 === e.result && e.preventDefault());
                return e.type = d,
                i || e.isDefaultPrevented() || u._default && !1 !== u._default.apply(f.pop(), t) || !X(n) || a && x(n[d]) && !g(n) && ((o = n[a]) && (n[a] = null),
                S.event.triggered = d,
                e.isPropagationStopped() && c.addEventListener(d, Et),
                n[d](),
                e.isPropagationStopped() && c.removeEventListener(d, Et),
                S.event.triggered = void 0,
                o && (n[a] = o)),
                e.result
            }
        },
        simulate: function(e, t, n) {
            e = S.extend(new S.Event, n, {
                type: e,
                isSimulated: !0
            });
            S.event.trigger(e, null, t)
        }
    }),
    S.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                S.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n)
                return S.event.trigger(e, t, n, !0)
        }
    }),
    y.focusin || S.each({
        focus: "focusin",
        blur: "focusout"
    }, function(n, i) {
        function r(e) {
            S.event.simulate(i, e.target, S.event.fix(e))
        }
        S.event.special[i] = {
            setup: function() {
                var e = this.ownerDocument || this.document || this
                  , t = Y.access(e, i);
                t || e.addEventListener(n, r, !0),
                Y.access(e, i, (t || 0) + 1)
            },
            teardown: function() {
                var e = this.ownerDocument || this.document || this
                  , t = Y.access(e, i) - 1;
                t ? Y.access(e, i, t) : (e.removeEventListener(n, r, !0),
                Y.remove(e, i))
            }
        }
    });
    var Nt = C.location
      , kt = {
        guid: Date.now()
    }
      , At = /\?/;
    S.parseXML = function(e) {
        var t, n;
        if (!e || "string" != typeof e)
            return null;
        try {
            t = (new C.DOMParser).parseFromString(e, "text/xml")
        } catch (e) {}
        return n = t && t.getElementsByTagName("parsererror")[0],
        t && !n || S.error("Invalid XML: " + (n ? S.map(n.childNodes, function(e) {
            return e.textContent
        }).join("\n") : e)),
        t
    }
    ;
    var Dt = /\[\]$/
      , jt = /\r?\n/g
      , Lt = /^(?:submit|button|image|reset|file)$/i
      , Pt = /^(?:input|select|textarea|keygen)/i;
    S.param = function(e, t) {
        function n(e, t) {
            t = x(t) ? t() : t,
            r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == t ? "" : t)
        }
        var i, r = [];
        if (null == e)
            return "";
        if (Array.isArray(e) || e.jquery && !S.isPlainObject(e))
            S.each(e, function() {
                n(this.name, this.value)
            });
        else
            for (i in e)
                !function n(i, e, r, o) {
                    if (Array.isArray(e))
                        S.each(e, function(e, t) {
                            r || Dt.test(i) ? o(i, t) : n(i + "[" + ("object" == typeof t && null != t ? e : "") + "]", t, r, o)
                        });
                    else if (r || "object" !== h(e))
                        o(i, e);
                    else
                        for (var t in e)
                            n(i + "[" + t + "]", e[t], r, o)
                }(i, e[i], t, n);
        return r.join("&")
    }
    ,
    S.fn.extend({
        serialize: function() {
            return S.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = S.prop(this, "elements");
                return e ? S.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !S(this).is(":disabled") && Pt.test(this.nodeName) && !Lt.test(e) && (this.checked || !ce.test(e))
            }).map(function(e, t) {
                var n = S(this).val();
                return null == n ? null : Array.isArray(n) ? S.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(jt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(jt, "\r\n")
                }
            }).get()
        }
    });
    var qt = /%20/g
      , Ot = /#.*$/
      , Ht = /([?&])_=[^&]*/
      , It = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , Mt = /^(?:GET|HEAD)$/
      , $t = /^\/\//
      , Rt = {}
      , _t = {}
      , Ft = "*/".concat("*")
      , Wt = E.createElement("a");
    function Bt(o) {
        return function(e, t) {
            "string" != typeof e && (t = e,
            e = "*");
            var n, i = 0, r = e.toLowerCase().match(H) || [];
            if (x(t))
                for (; n = r[i++]; )
                    "+" === n[0] ? (n = n.slice(1) || "*",
                    (o[n] = o[n] || []).unshift(t)) : (o[n] = o[n] || []).push(t)
        }
    }
    function zt(t, i, r, o) {
        var s = {}
          , a = t === _t;
        function l(e) {
            var n;
            return s[e] = !0,
            S.each(t[e] || [], function(e, t) {
                t = t(i, r, o);
                return "string" != typeof t || a || s[t] ? a ? !(n = t) : void 0 : (i.dataTypes.unshift(t),
                l(t),
                !1)
            }),
            n
        }
        return l(i.dataTypes[0]) || !s["*"] && l("*")
    }
    function Vt(e, t) {
        var n, i, r = S.ajaxSettings.flatOptions || {};
        for (n in t)
            void 0 !== t[n] && ((r[n] ? e : i = i || {})[n] = t[n]);
        return i && S.extend(!0, e, i),
        e
    }
    Wt.href = Nt.href,
    S.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Nt.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Nt.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Ft,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": S.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Vt(Vt(e, S.ajaxSettings), t) : Vt(S.ajaxSettings, e)
        },
        ajaxPrefilter: Bt(Rt),
        ajaxTransport: Bt(_t),
        ajax: function(e, t) {
            "object" == typeof e && (t = e,
            e = void 0),
            t = t || {};
            var l, u, c, n, f, i, d, p, r, o, h = S.ajaxSetup({}, t), g = h.context || h, v = h.context && (g.nodeType || g.jquery) ? S(g) : S.event, m = S.Deferred(), y = S.Callbacks("once memory"), x = h.statusCode || {}, s = {}, a = {}, b = "canceled", w = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (d) {
                        if (!n)
                            for (n = {}; t = It.exec(c); )
                                n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
                        t = n[e.toLowerCase() + " "]
                    }
                    return null == t ? null : t.join(", ")
                },
                getAllResponseHeaders: function() {
                    return d ? c : null
                },
                setRequestHeader: function(e, t) {
                    return null == d && (e = a[e.toLowerCase()] = a[e.toLowerCase()] || e,
                    s[e] = t),
                    this
                },
                overrideMimeType: function(e) {
                    return null == d && (h.mimeType = e),
                    this
                },
                statusCode: function(e) {
                    if (e)
                        if (d)
                            w.always(e[w.status]);
                        else
                            for (var t in e)
                                x[t] = [x[t], e[t]];
                    return this
                },
                abort: function(e) {
                    e = e || b;
                    return l && l.abort(e),
                    T(0, e),
                    this
                }
            };
            if (m.promise(w),
            h.url = ((e || h.url || Nt.href) + "").replace($t, Nt.protocol + "//"),
            h.type = t.method || t.type || h.method || h.type,
            h.dataTypes = (h.dataType || "*").toLowerCase().match(H) || [""],
            null == h.crossDomain) {
                i = E.createElement("a");
                try {
                    i.href = h.url,
                    i.href = i.href,
                    h.crossDomain = Wt.protocol + "//" + Wt.host != i.protocol + "//" + i.host
                } catch (e) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = S.param(h.data, h.traditional)),
            zt(Rt, h, t, w),
            d)
                return w;
            for (r in (p = S.event && h.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
            h.type = h.type.toUpperCase(),
            h.hasContent = !Mt.test(h.type),
            u = h.url.replace(Ot, ""),
            h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(qt, "+")) : (o = h.url.slice(u.length),
            h.data && (h.processData || "string" == typeof h.data) && (u += (At.test(u) ? "&" : "?") + h.data,
            delete h.data),
            !1 === h.cache && (u = u.replace(Ht, "$1"),
            o = (At.test(u) ? "&" : "?") + "_=" + kt.guid++ + o),
            h.url = u + o),
            h.ifModified && (S.lastModified[u] && w.setRequestHeader("If-Modified-Since", S.lastModified[u]),
            S.etag[u] && w.setRequestHeader("If-None-Match", S.etag[u])),
            (h.data && h.hasContent && !1 !== h.contentType || t.contentType) && w.setRequestHeader("Content-Type", h.contentType),
            w.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Ft + "; q=0.01" : "") : h.accepts["*"]),
            h.headers)
                w.setRequestHeader(r, h.headers[r]);
            if (h.beforeSend && (!1 === h.beforeSend.call(g, w, h) || d))
                return w.abort();
            if (b = "abort",
            y.add(h.complete),
            w.done(h.success),
            w.fail(h.error),
            l = zt(_t, h, t, w)) {
                if (w.readyState = 1,
                p && v.trigger("ajaxSend", [w, h]),
                d)
                    return w;
                h.async && 0 < h.timeout && (f = C.setTimeout(function() {
                    w.abort("timeout")
                }, h.timeout));
                try {
                    d = !1,
                    l.send(s, T)
                } catch (e) {
                    if (d)
                        throw e;
                    T(-1, e)
                }
            } else
                T(-1, "No Transport");
            function T(e, t, n, i) {
                var r, o, s, a = t;
                d || (d = !0,
                f && C.clearTimeout(f),
                l = void 0,
                c = i || "",
                w.readyState = 0 < e ? 4 : 0,
                i = 200 <= e && e < 300 || 304 === e,
                n && (s = function(e, t, n) {
                    for (var i, r, o, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
                        l.shift(),
                        void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (i)
                        for (r in a)
                            if (a[r] && a[r].test(i)) {
                                l.unshift(r);
                                break
                            }
                    if (l[0]in n)
                        o = l[0];
                    else {
                        for (r in n) {
                            if (!l[0] || e.converters[r + " " + l[0]]) {
                                o = r;
                                break
                            }
                            s = s || r
                        }
                        o = o || s
                    }
                    if (o)
                        return o !== l[0] && l.unshift(o),
                        n[o]
                }(h, w, n)),
                !i && -1 < S.inArray("script", h.dataTypes) && S.inArray("json", h.dataTypes) < 0 && (h.converters["text script"] = function() {}
                ),
                s = function(e, t, n, i) {
                    var r, o, s, a, l, u = {}, c = e.dataTypes.slice();
                    if (c[1])
                        for (s in e.converters)
                            u[s.toLowerCase()] = e.converters[s];
                    for (o = c.shift(); o; )
                        if (e.responseFields[o] && (n[e.responseFields[o]] = t),
                        !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                        l = o,
                        o = c.shift())
                            if ("*" === o)
                                o = l;
                            else if ("*" !== l && l !== o) {
                                if (!(s = u[l + " " + o] || u["* " + o]))
                                    for (r in u)
                                        if ((a = r.split(" "))[1] === o && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                            !0 === s ? s = u[r] : !0 !== u[r] && (o = a[0],
                                            c.unshift(a[1]));
                                            break
                                        }
                                if (!0 !== s)
                                    if (s && e.throws)
                                        t = s(t);
                                    else
                                        try {
                                            t = s(t)
                                        } catch (e) {
                                            return {
                                                state: "parsererror",
                                                error: s ? e : "No conversion from " + l + " to " + o
                                            }
                                        }
                            }
                    return {
                        state: "success",
                        data: t
                    }
                }(h, s, w, i),
                i ? (h.ifModified && ((n = w.getResponseHeader("Last-Modified")) && (S.lastModified[u] = n),
                (n = w.getResponseHeader("etag")) && (S.etag[u] = n)),
                204 === e || "HEAD" === h.type ? a = "nocontent" : 304 === e ? a = "notmodified" : (a = s.state,
                r = s.data,
                i = !(o = s.error))) : (o = a,
                !e && a || (a = "error",
                e < 0 && (e = 0))),
                w.status = e,
                w.statusText = (t || a) + "",
                i ? m.resolveWith(g, [r, a, w]) : m.rejectWith(g, [w, a, o]),
                w.statusCode(x),
                x = void 0,
                p && v.trigger(i ? "ajaxSuccess" : "ajaxError", [w, h, i ? r : o]),
                y.fireWith(g, [w, a]),
                p && (v.trigger("ajaxComplete", [w, h]),
                --S.active || S.event.trigger("ajaxStop")))
            }
            return w
        },
        getJSON: function(e, t, n) {
            return S.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return S.get(e, void 0, t, "script")
        }
    }),
    S.each(["get", "post"], function(e, r) {
        S[r] = function(e, t, n, i) {
            return x(t) && (i = i || n,
            n = t,
            t = void 0),
            S.ajax(S.extend({
                url: e,
                type: r,
                dataType: i,
                data: t,
                success: n
            }, S.isPlainObject(e) && e))
        }
    }),
    S.ajaxPrefilter(function(e) {
        for (var t in e.headers)
            "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
    }),
    S._evalUrl = function(e, t, n) {
        return S.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(e) {
                S.globalEval(e, t, n)
            }
        })
    }
    ,
    S.fn.extend({
        wrapAll: function(e) {
            return this[0] && (x(e) && (e = e.call(this[0])),
            e = S(e, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && e.insertBefore(this[0]),
            e.map(function() {
                for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                return e
            }).append(this)),
            this
        },
        wrapInner: function(n) {
            return x(n) ? this.each(function(e) {
                S(this).wrapInner(n.call(this, e))
            }) : this.each(function() {
                var e = S(this)
                  , t = e.contents();
                t.length ? t.wrapAll(n) : e.append(n)
            })
        },
        wrap: function(t) {
            var n = x(t);
            return this.each(function(e) {
                S(this).wrapAll(n ? t.call(this, e) : t)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                S(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    S.expr.pseudos.hidden = function(e) {
        return !S.expr.pseudos.visible(e)
    }
    ,
    S.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }
    ,
    S.ajaxSettings.xhr = function() {
        try {
            return new C.XMLHttpRequest
        } catch (e) {}
    }
    ;
    var Ut = {
        0: 200,
        1223: 204
    }
      , Xt = S.ajaxSettings.xhr();
    y.cors = !!Xt && "withCredentials"in Xt,
    y.ajax = Xt = !!Xt,
    S.ajaxTransport(function(r) {
        var o, s;
        if (y.cors || Xt && !r.crossDomain)
            return {
                send: function(e, t) {
                    var n, i = r.xhr();
                    if (i.open(r.type, r.url, r.async, r.username, r.password),
                    r.xhrFields)
                        for (n in r.xhrFields)
                            i[n] = r.xhrFields[n];
                    for (n in r.mimeType && i.overrideMimeType && i.overrideMimeType(r.mimeType),
                    r.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"),
                    e)
                        i.setRequestHeader(n, e[n]);
                    o = function(e) {
                        return function() {
                            o && (o = s = i.onload = i.onerror = i.onabort = i.ontimeout = i.onreadystatechange = null,
                            "abort" === e ? i.abort() : "error" === e ? "number" != typeof i.status ? t(0, "error") : t(i.status, i.statusText) : t(Ut[i.status] || i.status, i.statusText, "text" !== (i.responseType || "text") || "string" != typeof i.responseText ? {
                                binary: i.response
                            } : {
                                text: i.responseText
                            }, i.getAllResponseHeaders()))
                        }
                    }
                    ,
                    i.onload = o(),
                    s = i.onerror = i.ontimeout = o("error"),
                    void 0 !== i.onabort ? i.onabort = s : i.onreadystatechange = function() {
                        4 === i.readyState && C.setTimeout(function() {
                            o && s()
                        })
                    }
                    ,
                    o = o("abort");
                    try {
                        i.send(r.hasContent && r.data || null)
                    } catch (e) {
                        if (o)
                            throw e
                    }
                },
                abort: function() {
                    o && o()
                }
            }
    }),
    S.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }),
    S.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return S.globalEval(e),
                e
            }
        }
    }),
    S.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1),
        e.crossDomain && (e.type = "GET")
    }),
    S.ajaxTransport("script", function(n) {
        var i, r;
        if (n.crossDomain || n.scriptAttrs)
            return {
                send: function(e, t) {
                    i = S("<script>").attr(n.scriptAttrs || {}).prop({
                        charset: n.scriptCharset,
                        src: n.url
                    }).on("load error", r = function(e) {
                        i.remove(),
                        r = null,
                        e && t("error" === e.type ? 404 : 200, e.type)
                    }
                    ),
                    E.head.appendChild(i[0])
                },
                abort: function() {
                    r && r()
                }
            }
    });
    var Qt = []
      , Yt = /(=)\?(?=&|$)|\?\?/;
    S.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Qt.pop() || S.expando + "_" + kt.guid++;
            return this[e] = !0,
            e
        }
    }),
    S.ajaxPrefilter("json jsonp", function(e, t, n) {
        var i, r, o, s = !1 !== e.jsonp && (Yt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Yt.test(e.data) && "data");
        if (s || "jsonp" === e.dataTypes[0])
            return i = e.jsonpCallback = x(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
            s ? e[s] = e[s].replace(Yt, "$1" + i) : !1 !== e.jsonp && (e.url += (At.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
            e.converters["script json"] = function() {
                return o || S.error(i + " was not called"),
                o[0]
            }
            ,
            e.dataTypes[0] = "json",
            r = C[i],
            C[i] = function() {
                o = arguments
            }
            ,
            n.always(function() {
                void 0 === r ? S(C).removeProp(i) : C[i] = r,
                e[i] && (e.jsonpCallback = t.jsonpCallback,
                Qt.push(i)),
                o && x(r) && r(o[0]),
                o = r = void 0
            }),
            "script"
    }),
    y.createHTMLDocument = ((f = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
    2 === f.childNodes.length),
    S.parseHTML = function(e, t, n) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t,
        t = !1),
        t || (y.createHTMLDocument ? ((i = (t = E.implementation.createHTMLDocument("")).createElement("base")).href = E.location.href,
        t.head.appendChild(i)) : t = E),
        i = !n && [],
        (n = A.exec(e)) ? [t.createElement(n[1])] : (n = me([e], t, i),
        i && i.length && S(i).remove(),
        S.merge([], n.childNodes)));
        var i
    }
    ,
    S.fn.load = function(e, t, n) {
        var i, r, o, s = this, a = e.indexOf(" ");
        return -1 < a && (i = bt(e.slice(a)),
        e = e.slice(0, a)),
        x(t) ? (n = t,
        t = void 0) : t && "object" == typeof t && (r = "POST"),
        0 < s.length && S.ajax({
            url: e,
            type: r || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            o = arguments,
            s.html(i ? S("<div>").append(S.parseHTML(e)).find(i) : e)
        }).always(n && function(e, t) {
            s.each(function() {
                n.apply(this, o || [e.responseText, t, e])
            })
        }
        ),
        this
    }
    ,
    S.expr.pseudos.animated = function(t) {
        return S.grep(S.timers, function(e) {
            return t === e.elem
        }).length
    }
    ,
    S.offset = {
        setOffset: function(e, t, n) {
            var i, r, o, s, a = S.css(e, "position"), l = S(e), u = {};
            "static" === a && (e.style.position = "relative"),
            o = l.offset(),
            i = S.css(e, "top"),
            s = S.css(e, "left"),
            s = ("absolute" === a || "fixed" === a) && -1 < (i + s).indexOf("auto") ? (r = (a = l.position()).top,
            a.left) : (r = parseFloat(i) || 0,
            parseFloat(s) || 0),
            x(t) && (t = t.call(e, n, S.extend({}, o))),
            null != t.top && (u.top = t.top - o.top + r),
            null != t.left && (u.left = t.left - o.left + s),
            "using"in t ? t.using.call(e, u) : l.css(u)
        }
    },
    S.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return void 0 === t ? this : this.each(function(e) {
                    S.offset.setOffset(this, t, e)
                });
            var e, n = this[0];
            return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(),
            n = n.ownerDocument.defaultView,
            {
                top: e.top + n.pageYOffset,
                left: e.left + n.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n, i = this[0], r = {
                    top: 0,
                    left: 0
                };
                if ("fixed" === S.css(i, "position"))
                    t = i.getBoundingClientRect();
                else {
                    for (t = this.offset(),
                    n = i.ownerDocument,
                    e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position"); )
                        e = e.parentNode;
                    e && e !== i && 1 === e.nodeType && ((r = S(e).offset()).top += S.css(e, "borderTopWidth", !0),
                    r.left += S.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - r.top - S.css(i, "marginTop", !0),
                    left: t.left - r.left - S.css(i, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === S.css(e, "position"); )
                    e = e.offsetParent;
                return e || ie
            })
        }
    }),
    S.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, r) {
        var o = "pageYOffset" === r;
        S.fn[t] = function(e) {
            return W(this, function(e, t, n) {
                var i;
                return g(e) ? i = e : 9 === e.nodeType && (i = e.defaultView),
                void 0 === n ? i ? i[r] : e[t] : void (i ? i.scrollTo(o ? i.pageXOffset : n, o ? n : i.pageYOffset) : e[t] = n)
            }, t, e, arguments.length)
        }
    }),
    S.each(["top", "left"], function(e, n) {
        S.cssHooks[n] = Ue(y.pixelPosition, function(e, t) {
            if (t)
                return t = Ve(e, n),
                We.test(t) ? S(e).position()[n] + "px" : t
        })
    }),
    S.each({
        Height: "height",
        Width: "width"
    }, function(s, a) {
        S.each({
            padding: "inner" + s,
            content: a,
            "": "outer" + s
        }, function(i, o) {
            S.fn[o] = function(e, t) {
                var n = arguments.length && (i || "boolean" != typeof e)
                  , r = i || (!0 === e || !0 === t ? "margin" : "border");
                return W(this, function(e, t, n) {
                    var i;
                    return g(e) ? 0 === o.indexOf("outer") ? e["inner" + s] : e.document.documentElement["client" + s] : 9 === e.nodeType ? (i = e.documentElement,
                    Math.max(e.body["scroll" + s], i["scroll" + s], e.body["offset" + s], i["offset" + s], i["client" + s])) : void 0 === n ? S.css(e, t, r) : S.style(e, t, n, r)
                }, a, n ? e : void 0, n)
            }
        })
    }),
    S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        S.fn[t] = function(e) {
            return this.on(t, e)
        }
    }),
    S.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        },
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }),
    S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, n) {
        S.fn[n] = function(e, t) {
            return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n)
        }
    });
    var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    S.proxy = function(e, t) {
        var n, i;
        if ("string" == typeof t && (i = e[t],
        t = e,
        e = i),
        x(e))
            return n = a.call(arguments, 2),
            (i = function() {
                return e.apply(t || this, n.concat(a.call(arguments)))
            }
            ).guid = e.guid = e.guid || S.guid++,
            i
    }
    ,
    S.holdReady = function(e) {
        e ? S.readyWait++ : S.ready(!0)
    }
    ,
    S.isArray = Array.isArray,
    S.parseJSON = JSON.parse,
    S.nodeName = k,
    S.isFunction = x,
    S.isWindow = g,
    S.camelCase = U,
    S.type = h,
    S.now = Date.now,
    S.isNumeric = function(e) {
        var t = S.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }
    ,
    S.trim = function(e) {
        return null == e ? "" : (e + "").replace(Gt, "")
    }
    ,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return S
    });
    var Jt = C.jQuery
      , Kt = C.$;
    return S.noConflict = function(e) {
        return C.$ === S && (C.$ = Kt),
        e && C.jQuery === S && (C.jQuery = Jt),
        S
    }
    ,
    void 0 === e && (C.jQuery = C.$ = S),
    S
});
var jQuery_T4NT = jQuery;
!function(e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jQuery_T4NT"], e) : "object" == typeof exports ? module.exports = e(require("jQuery_T4NT")) : e(jQuery_T4NT)
}(function(o) {
    "use strict";
    function n(e, t) {
        function n(e) {
            void 0 !== e.open && (e.open = !e.open)
        }
        var i = function(e) {
            for (var t, n = [], i = e.parentNode; (t = i) && (0 === t.offsetWidth || 0 === t.offsetHeight || !1 === t.open); )
                n.push(i),
                i = i.parentNode;
            return n
        }(e)
          , r = i.length
          , o = []
          , s = e[t];
        if (r) {
            for (var a = 0; a < r; a++)
                o[a] = i[a].style.cssText,
                i[a].style.setProperty ? i[a].style.setProperty("display", "block", "important") : i[a].style.cssText += ";display: block !important",
                i[a].style.height = "0",
                i[a].style.overflow = "hidden",
                i[a].style.visibility = "hidden",
                n(i[a]);
            s = e[t];
            for (var l = 0; l < r; l++)
                i[l].style.cssText = o[l],
                n(i[l])
        }
        return s
    }
    function i(e, t) {
        e = parseFloat(e);
        return Number.isNaN(e) ? t : e
    }
    function r(e) {
        return e.charAt(0).toUpperCase() + e.substr(1)
    }
    function s(e, t) {
        if (this.$window = o(window),
        this.$document = o(document),
        this.$element = o(e),
        this.options = o.extend({}, c, t),
        this.polyfill = this.options.polyfill,
        this.orientation = this.$element[0].getAttribute("data-orientation") || this.options.orientation,
        this.onInit = this.options.onInit,
        this.onSlide = this.options.onSlide,
        this.onSlideEnd = this.options.onSlideEnd,
        this.DIMENSION = f.orientation[this.orientation].dimension,
        this.DIRECTION = f.orientation[this.orientation].direction,
        this.DIRECTION_STYLE = f.orientation[this.orientation].directionStyle,
        this.COORDINATE = f.orientation[this.orientation].coordinate,
        this.polyfill && u)
            return !1;
        this.identifier = "js-" + a + "-" + l++,
        this.startEvent = this.options.startEvent.join("." + this.identifier + " ") + "." + this.identifier,
        this.moveEvent = this.options.moveEvent.join("." + this.identifier + " ") + "." + this.identifier,
        this.endEvent = this.options.endEvent.join("." + this.identifier + " ") + "." + this.identifier,
        this.toFixed = (this.step + "").replace(".", "").length - 1,
        this.$fill = o('<div class="' + this.options.fillClass + '" />'),
        this.$handle = o('<div class="' + this.options.handleClass + '" />'),
        this.$range = o('<div class="' + this.options.rangeClass + " " + this.options[this.orientation + "Class"] + '" id="' + this.identifier + '" />').insertAfter(this.$element).prepend(this.$fill, this.$handle),
        this.$element.css({
            position: "absolute",
            width: "1px",
            height: "1px",
            overflow: "hidden",
            opacity: "0"
        }),
        this.handleDown = o.proxy(this.handleDown, this),
        this.handleMove = o.proxy(this.handleMove, this),
        this.handleEnd = o.proxy(this.handleEnd, this),
        this.init();
        var n, i, r = this;
        this.$window.on("resize." + this.identifier, (n = function() {
            !function(e, t) {
                var n = Array.prototype.slice.call(arguments, 2);
                setTimeout(function() {
                    return e.apply(null, n)
                }, t)
            }(function() {
                r.update(!1, !1)
            }, 300)
        }
        ,
        i = (i = 20) || 100,
        function() {
            var e;
            return n.debouncing || (e = Array.prototype.slice.apply(arguments),
            n.lastReturnVal = n.apply(window, e),
            n.debouncing = !0),
            clearTimeout(n.debounceTimeout),
            n.debounceTimeout = setTimeout(function() {
                n.debouncing = !1
            }, i),
            n.lastReturnVal
        }
        )),
        this.$document.on(this.startEvent, "#" + this.identifier + ":not(." + this.options.disabledClass + ")", this.handleDown),
        this.$element.on("change." + this.identifier, function(e, t) {
            t && t.origin === r.identifier || (e = e.target.value,
            e = r.getPositionFromValue(e),
            r.setPosition(e))
        })
    }
    Number.isNaN = Number.isNaN || function(e) {
        return "number" == typeof e && e != e
    }
    ;
    var e, a = "rangeslider", l = 0, u = ((e = document.createElement("input")).setAttribute("type", "range"),
    "text" !== e.type), c = {
        polyfill: !0,
        orientation: "horizontal",
        rangeClass: "rangeslider",
        disabledClass: "rangeslider--disabled",
        activeClass: "rangeslider--active",
        horizontalClass: "rangeslider--horizontal",
        verticalClass: "rangeslider--vertical",
        fillClass: "rangeslider__fill",
        handleClass: "rangeslider__handle",
        startEvent: ["mousedown", "touchstart", "pointerdown"],
        moveEvent: ["mousemove", "touchmove", "pointermove"],
        endEvent: ["mouseup", "touchend", "pointerup"]
    }, f = {
        orientation: {
            horizontal: {
                dimension: "width",
                direction: "left",
                directionStyle: "left",
                coordinate: "x"
            },
            vertical: {
                dimension: "height",
                direction: "top",
                directionStyle: "bottom",
                coordinate: "y"
            }
        }
    };
    return s.prototype.init = function() {
        this.update(!0, !1),
        this.onInit && "function" == typeof this.onInit && this.onInit()
    }
    ,
    s.prototype.update = function(e, t) {
        (e = e || !1) && (this.min = i(this.$element[0].getAttribute("min"), 0),
        this.max = i(this.$element[0].getAttribute("max"), 100),
        this.value = i(this.$element[0].value, Math.round(this.min + (this.max - this.min) / 2)),
        this.step = i(this.$element[0].getAttribute("step"), 1)),
        this.handleDimension = n(this.$handle[0], "offset" + r(this.DIMENSION)),
        this.rangeDimension = n(this.$range[0], "offset" + r(this.DIMENSION)),
        this.maxHandlePos = this.rangeDimension - this.handleDimension,
        this.grabPos = this.handleDimension / 2,
        this.position = this.getPositionFromValue(this.value),
        this.$element[0].disabled ? this.$range.addClass(this.options.disabledClass) : this.$range.removeClass(this.options.disabledClass),
        this.setPosition(this.position, t)
    }
    ,
    s.prototype.handleDown = function(e) {
        var t, n;
        e.preventDefault(),
        this.$document.on(this.moveEvent, this.handleMove),
        this.$document.on(this.endEvent, this.handleEnd),
        this.$range.addClass(this.options.activeClass),
        -1 < (" " + e.target.className + " ").replace(/[\n\t]/g, " ").indexOf(this.options.handleClass) || (t = this.getRelativePosition(e),
        n = this.$range[0].getBoundingClientRect()[this.DIRECTION],
        e = this.getPositionFromNode(this.$handle[0]) - n,
        n = "vertical" === this.orientation ? this.maxHandlePos - (t - this.grabPos) : t - this.grabPos,
        this.setPosition(n),
        e <= t && t < e + this.handleDimension && (this.grabPos = t - e))
    }
    ,
    s.prototype.handleMove = function(e) {
        e.preventDefault();
        e = this.getRelativePosition(e),
        e = "vertical" === this.orientation ? this.maxHandlePos - (e - this.grabPos) : e - this.grabPos;
        this.setPosition(e)
    }
    ,
    s.prototype.handleEnd = function(e) {
        e.preventDefault(),
        this.$document.off(this.moveEvent, this.handleMove),
        this.$document.off(this.endEvent, this.handleEnd),
        this.$range.removeClass(this.options.activeClass),
        this.$element.trigger("change", {
            origin: this.identifier
        }),
        this.onSlideEnd && "function" == typeof this.onSlideEnd && this.onSlideEnd(this.position, this.value)
    }
    ,
    s.prototype.cap = function(e, t, n) {
        return e < t ? t : n < e ? n : e
    }
    ,
    s.prototype.setPosition = function(e, t) {
        var n;
        void 0 === t && (t = !0),
        n = this.getValueFromPosition(this.cap(e, 0, this.maxHandlePos)),
        e = this.getPositionFromValue(n),
        this.$fill[0].style[this.DIMENSION] = e + this.grabPos + "px",
        this.$handle[0].style[this.DIRECTION_STYLE] = e + "px",
        this.setValue(n),
        this.position = e,
        this.value = n,
        t && this.onSlide && "function" == typeof this.onSlide && this.onSlide(e, n)
    }
    ,
    s.prototype.getPositionFromNode = function(e) {
        for (var t = 0; null !== e; )
            t += e.offsetLeft,
            e = e.offsetParent;
        return t
    }
    ,
    s.prototype.getRelativePosition = function(e) {
        var t = r(this.COORDINATE)
          , n = this.$range[0].getBoundingClientRect()[this.DIRECTION]
          , i = 0;
        return void 0 !== e.originalEvent["client" + t] ? i = e.originalEvent["client" + t] : e.originalEvent.touches && e.originalEvent.touches[0] && void 0 !== e.originalEvent.touches[0]["client" + t] ? i = e.originalEvent.touches[0]["client" + t] : e.currentPoint && void 0 !== e.currentPoint[this.COORDINATE] && (i = e.currentPoint[this.COORDINATE]),
        i - n
    }
    ,
    s.prototype.getPositionFromValue = function(e) {
        e = (e - this.min) / (this.max - this.min);
        return Number.isNaN(e) ? 0 : e * this.maxHandlePos
    }
    ,
    s.prototype.getValueFromPosition = function(e) {
        var e = e / (this.maxHandlePos || 1)
          , e = this.step * Math.round(e * (this.max - this.min) / this.step) + this.min;
        return Number(e.toFixed(this.toFixed))
    }
    ,
    s.prototype.setValue = function(e) {
        e === this.value && "" !== this.$element[0].value || this.$element.val(e).trigger("input", {
            origin: this.identifier
        })
    }
    ,
    s.prototype.destroy = function() {
        this.$document.off("." + this.identifier),
        this.$window.off("." + this.identifier),
        this.$element.off("." + this.identifier).removeAttr("style").removeData("plugin_" + a),
        this.$range && this.$range.length && this.$range[0].parentNode.removeChild(this.$range[0])
    }
    ,
    o.fn[a] = function(n) {
        var i = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var e = o(this)
              , t = e.data("plugin_" + a);
            t || e.data("plugin_" + a, t = new s(this,n)),
            "string" == typeof n && t[n].apply(t, i)
        })
    }
    ,
    "rangeslider.js is available in jQuery_T4NT context e.g $(selector).rangeslider(options);"
}),
function(c) {
    var e, t, n, f = c('[type="radio"][value="casual"]').data("length"), d = c('[type="radio"][value="intermediate"]').data("length"), p = c('[type="radio"][value="experienced"]').data("length"), h = c('[type="radio"][value="pro"]').data("length"), g = c('[type="radio"][value="casual"]').data("volume"), v = c('[type="radio"][value="intermediate"]').data("volume"), m = c('[type="radio"][value="experienced"]').data("volume"), y = c('[type="radio"][value="pro"]').data("volume"), x = (parseFloat(c("#toleranceId").val()),
    /\d\'\d.*?\ /g);
    function i(button_trigger) {
        var e = c("#heightslider").val();
        console.log("heightvalue: ", e);
        var t = .3937 * e / 12;        
        var n = Math.floor(t);
        let mathRound = Math.round(12 * (t - n))
        var i = n + "'" + mathRound + '"' + " / " + e + "cm";
        heightslider = Number(e);
        if(["152", "182", "212"].includes(e)){
           if(button_trigger == "heightadd"){             
             e = Number(e) + 2;             
           }else if(button_trigger == "heightreduce"){
             e = Number(e) - 2;             
           }           
           document.querySelector('#heightslider').value = e;           
          t = .3937 * e / 12
          n = Math.floor(t)
          i = n + "'" + Math.round(12 * (t - n)) + '"' + " / " + e + "cm";
        }
        c("#heightslider").next("output").empty().append(i);
        t = c("#heightslider"),
        n = t.width(),
        c("output").next().width(),
        outerWidth,
        e = (t.val() - t.attr("min")) / (t.attr("max") - t.attr("min")),
        i = 1.5;
        e < 0 ? newPlace = 0 : 1 < e ? newPlace = n : (newPlace = n * e + i,
        i -= e),
        t.next("output").css({
            left: newPlace,
            marginLeft: i + "%"
        })
        console.log({t, t, e})
    }
    function r() {
        var e = c("#weightslider")
          , t = e.val()
          , n = (2.20462 * t).toFixed(0) + "lbs / " + t + "kg";
        e.next("output").empty().append(n);
        var i = e.width()
          , t = (c(e).next("output").width(),
        outerWidth,
        (e.val() - e.attr("min")) / (e.attr("max") - e.attr("min")))
          , n = .5;
        t < 0 ? newPlace = 0 : 1 < t ? newPlace = i : (newPlace = i * t + n,
        n -= t),
        e.next("output").css({
            left: newPlace,
            marginLeft: n + "%"
        })
    }
    c("#calculate").click(function(e) {
        e.preventDefault(),
        function() {
            c(".result").each(function() {
                c(this).removeClass("suggested suggestedlength")
            });
            var e, t = c("input:radio[name ='ability']:checked").val(), n = c("#weightslider").val(), i = c("#heightslider").val();
            i += "0",
            "casual" == t ? e = n * g : "intermediate" == t ? e = n * v : "experienced" == t ? e = n * m : "pro" == t && (e = n * y);
            var r = e.toFixed(2);
            c(".volumesuggestresult").empty().append(r),
            c(".volumesuggest").show(),
            "casual" == t ? o = +i + +f : "intermediate" == t ? o = +i + +d : "experienced" == t ? o = +i + +p : "pro" == t && (o = +i + +h);
            var r = (o /= 25.4) / 12
              , o = Math.floor(r)
              , r = Math.round(12 * (r - o))
              , s = o + "'" + r + '"';
            console.log("feetresult: ", s);
            var a = new Array;
            c(".result.stock").each(function() {
                var e = c(this).text().toLowerCase()
                  , t = (t = e.replace("’", "'")).match(x)[0].replace(" ", "");
                console.log("t4_text: ", t),
                t == s && (e = e.split(" - ")[1],
                a.push(e.replace("l", "")),
                c(this).addClass("suggestedlength"))
            }),
            new Array,
            r = Math.max.apply(Math, a),
            Math.min.apply(Math, a);
            let l = null;
            c.each(a, function() {
                (null == l || Math.abs(this - e) < Math.abs(l - e)) && (l = this)
            }),
            console.log("closest: ", l),
            c(".result.suggestedlength").each(function() {
                var e = c(this).text().toLowerCase().split(" - ")[1];
                console.log("t4_volume: ", e),
                e.replace("l", "") == l && c(this).addClass("suggested")
            });
            var u = c(".result.suggestedlength.suggested").text();
            if ("" == u)
                return c(".js_result_custom").show(),
                c(".js_result_title").hide();
            c(".js_result_title").text(u).show(),
            c(".js_result_custom").hide(),
            c("#callBackVariant_ppr .nt-swatch").each(function() {
                if (console.log("suggested_txt: ", u),
                c(this).find(".swatch__value_pr").text().toLowerCase() == u.toLowerCase())
                    return c(this).trigger("click"),
                    !1
            }),
            localStorage.setItem("ability", t),
            localStorage.setItem("rawweight", n),
            localStorage.setItem("rawheight", i)
        }()
    }),
    localStorage.ability && function() {
        c(".result").each(function() {
            c(this).removeClass("suggested suggestedlength")
        });
        var e, t = localStorage.ability, n = localStorage.rawweight, i = localStorage.rawheight;
        "casual" == t ? e = n * g : "intermediate" == t ? e = n * v : "experienced" == t ? e = n * m : "pro" == t && (e = n * y),
        n = e.toFixed(2),
        c(".volumesuggestresult").empty().append(n),
        c(".volumesuggest").show(),
        "casual" == t ? r = +i + +f : "intermediate" == t ? r = +i + +d : "experienced" == t ? r = +i + +p : "pro" == t && (r = +i + +h);
        var i = (r /= 25.4) / 12
          , r = Math.floor(i)
          , i = Math.round(12 * (i - r))
          , o = r + "'" + i + '"'
          , s = new Array;
        console.log("feetresult: ", o),
        c(".result.stock").each(function() {
            var e = c(this).text().toLowerCase()
              , t = (t = e.replace("’", "'")).match(x)[0].replace(" ", "");
            console.log("t4_text: ", t),
            t == o && (e = e.split(" - ")[1],
            s.push(e.replace("l", "")),
            console.log("t4_volume: ", e),
            c(this).addClass("suggestedlength"))
        }),
        new Array,
        i = Math.max.apply(Math, s),
        Math.min.apply(Math, s);
        let a = null;
        c.each(s, function() {
            (null == a || Math.abs(this - e) < Math.abs(a - e)) && (a = this)
        }),
        console.log("closest: ", a),
        c(".result.suggestedlength").each(function() {
            var e = c(this).text().toLowerCase().split(" - ")[1];
            console.log("t4_volume: ", e),
            e.replace("l", "") == a && c(this).addClass("suggested")
        });
        var l = c(".result.suggestedlength.suggested").text();
        if ("" == l)
            return c(".js_result_custom").show(),
            c(".js_result_title").hide();
        c(".js_result_title").text(l).show(),
        c(".js_result_custom").hide(),
        c("#callBackVariant_ppr .nt-swatch").each(function() {
            if (c(this).find(".swatch__value_pr").text().toLowerCase() == l.toLowerCase())
                return console.log(c(this)),
                c("#callBackVariant_ppr .is-selected-nt").removeClass("is-selected-nt"),
                c(this).addClass("is-selected-nt").trigger("click"),
                !1
        })
    }(),
    c('input[type="range"]').rangeslider(),
    c(document).ready(function() {
        r(),
        i(),
        setTimeout(function() {
            r(),
            i()
        }, 500),
        setTimeout(function() {
            r(),
            i()
        }, 1e3)
    }),
    localStorage.rawweight && (e = localStorage.ability,
    t = localStorage.rawweight,
    n = localStorage.rawheight,
    n /= 10,
    c("input:radio[name=ability]").filter("[value=" + e + "]").prop("checked", !0),
    c("#heightslider").val(n).change(),
    c("#weightslider").val(t).change()),
    c(document).on("click touchstart", "#heightreduce", function() {
        c(this).css("background-color", "#F3F3F5");
        var e = c("#heightslider").val()
          , e = parseInt(e);
        e -= 2,
        c("#heightslider").val(e),
        i("heightreduce")
    }),
    c(document).on("click touchstart", "#heightadd", function() {
        var e = c("#heightslider").val()
          , e = parseInt(e);
        e += 2,
        c("#heightslider").val(e),
        i("heightadd")
    }),
    c(document).on("click touchstart", "#weightreduce", function() {
        var e = c("#weightslider").val()
          , e = parseInt(e);
        e -= 2,
        c("#weightslider").val(e),
        r()
    }),
    c(document).on("click touchstart", "#weightadd", function() {
        var e = c("#weightslider").val()
          , e = parseInt(e);
        e += 2,
        c("#weightslider").val(e),
        r()
    }),
    c("#weightslider").change(function() {
        r()
    }),
    heightslider = Number(c("#heightslider").val()),
    c("#heightslider").change(function() {
      var changesHeight = Number(c("#heightslider").val());
      console.log({changesHeight, heightslider})
      if(changesHeight >= heightslider){
        i("heightadd");
      }else{
        i("heightreduce");
      }
    }),
    c.fn.isOnScreen = function() {
        var e = c(window)
          , t = {
            top: e.scrollTop(),
            left: e.scrollLeft()
        };
        t.right = t.left + e.width(),
        t.bottom = t.top + e.height();
        e = this.offset();
        return e.right = e.left + this.outerWidth(),
        e.bottom = e.top + this.outerHeight(),
        !(t.right < e.left || t.left > e.right || t.bottom < e.top || t.top > e.bottom)
    }
}(jQuery_T4NT);
